// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAddDiagnosisRequest = z.object({
    diagnosis_code: z.string(),
    diagnosis_description: z.string(),
    diagnosis_type: z.string(),
    rank: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

export const zAddGroupGrantRequest = z.object({
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zAddGroupMemberRequest = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zAdminUserRow = z.object({
    created_at: z.iso.datetime(),
    email: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    facility_name: z.string(),
    full_name: z.string(),
    is_active: z.boolean(),
    last_login: z.iso.datetime().nullish(),
    ldap_directory_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ldap_dn: z.string().nullish(),
    roles: z.array(z.string()),
    sso_issuer: z.string().nullish(),
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    username: z.string()
});

export const zAdministrationRequest = z.object({
    administered_at: z.string().nullish(),
    barcode_override_reason: z.string().nullish(),
    dose_given: z.string().nullish(),
    double_check_override_reason: z.string().nullish(),
    hold_reason: z.string().nullish(),
    medication_barcode: z.string().nullish(),
    notes: z.string().nullish(),
    patient_barcode: z.string().nullish(),
    pharmacy_override_reason: z.string().nullish(),
    route: z.string().nullish(),
    scheduled_time: z.string().nullish(),
    site: z.string().nullish(),
    status: z.string()
});

export const zAdministrationResponse = z.object({
    administered_at: z.string(),
    administered_by_name: z.string(),
    administered_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    administration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    barcode_scanned: z.boolean(),
    created_at: z.string(),
    dose_given: z.string(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    hold_reason: z.string().nullish(),
    medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    route: z.string(),
    site: z.string().nullish(),
    status: z.string()
});

export const zAllergySummary = z.object({
    allergen_name: z.string(),
    allergy_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    reaction_type: z.string().nullish(),
    severity: z.string()
});

export const zAmendNoteRequest = z.object({
    amended_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    amendment_reason: z.string()
});

/**
 * API error response
 */
export const zApiError = z.object({
    error: z.string(),
    message: z.string()
});

/**
 * Success response wrapper
 */
export const zApiResponseHl7MessageResponse = z.object({
    data: z.object({
        acknowledgment_code: z.string().nullish(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        error_message: z.string().nullish(),
        message_control_id: z.string(),
        message_event: z.string(),
        message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        message_type: z.string(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        processed_datetime: z.iso.datetime().nullish(),
        processing_status: z.string(),
        received_datetime: z.iso.datetime()
    }),
    success: z.boolean()
});

/**
 * Success response wrapper
 */
export const zApiResponseHl7MessageStats = z.object({
    data: z.object({
        avg_processing_time_ms: z.number().nullish(),
        pending_in_queue: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        total_errors: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        total_processed: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        total_received: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        total_rejected: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
    }),
    success: z.boolean()
});

/**
 * Success response wrapper
 */
export const zApiResponseVecHl7MessageResponse = z.object({
    data: z.array(z.object({
        acknowledgment_code: z.string().nullish(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        error_message: z.string().nullish(),
        message_control_id: z.string(),
        message_event: z.string(),
        message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        message_type: z.string(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        processed_datetime: z.iso.datetime().nullish(),
        processing_status: z.string(),
        received_datetime: z.iso.datetime()
    })),
    success: z.boolean()
});

export const zAppointmentResponse = z.object({
    appointment_datetime: z.iso.datetime(),
    appointment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    appointment_number: z.string(),
    appointment_type: z.string(),
    arrival_datetime: z.iso.datetime().nullish(),
    arrived: z.boolean().nullish(),
    authorization_number: z.string().nullish(),
    authorization_verified: z.boolean().nullish(),
    cancellation_reason: z.string().nullish(),
    check_in_time: z.iso.datetime().nullish(),
    copay_amount: z.string().nullish(),
    copay_collected: z.boolean().nullish(),
    created_at: z.iso.datetime(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    end_datetime: z.iso.datetime().nullish(),
    external_appointment_id: z.string().nullish(),
    external_provider_name: z.string().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    hl7_message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    insurance_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    modified_at: z.iso.datetime().nullish(),
    mrn: z.string().nullish(),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    provider_name: z.string().nullish(),
    reason: z.string().nullish(),
    room_number: z.string().nullish(),
    source_system: z.string().nullish(),
    status: z.string()
});

export const zAppointmentSummary = z.object({
    appointment_datetime: z.iso.datetime(),
    appointment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    appointment_type: z.string(),
    facility_time_zone: z.string().nullish(),
    provider_name: z.string().nullish(),
    status: z.string()
});

/**
 * Grant one role at one facility scope. `facility_id: None` is a
 * health-system-wide grant — it widens PATIENT access, not merely reporting
 * reach, because the JWT's `facility_ids` claim comes entirely from these rows.
 *
 * `department_id` was removed from the role grant — see `UserRoleAssignment`.
 */
export const zAssignRoleRequest = z.object({
    effective_date: z.iso.date().nullish(),
    expiration_date: z.iso.date().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * `GET /admin/interfaces/messages/:id/attempts` — full per-attempt
 * audit trail for an outbound queue row. Sourced from
 * `OutboundHL7QueueAttempt` (`0110_integration.sql`), populated by
 * `outbound_worker::process_claimed`.
 *
 * Returns an empty list for inbound messages: the inbound store path
 * is single-shot per MSH-10 (retransmissions return the cached ACK
 * without a new processing pass), so there is no per-attempt history
 * to report. The UI's `Attempts` component already special-cases the
 * "direction=in" message and shows an explainer.
 */
export const zAttemptRow = z.object({
    ack_code: z.string().nullish(),
    attempt_id: z.uuid(),
    attempted_at: z.iso.datetime(),
    duration_ms: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    error_text: z.string().nullish(),
    outcome: z.string()
});

export const zAvailableSlotResponse = z.object({
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    provider_name: z.string().nullish(),
    slot_datetime: z.iso.datetime()
});

export const zBatchAcknowledgeCriticalRequest = z.object({
    result_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))
});

export const zBreakGlassRequest = z.object({
    justification: z.string(),
    password: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    totp_code: z.string().nullish()
});

export const zBreakGlassResponse = z.object({
    expires_in_seconds: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    granted: z.boolean(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCancelAppointmentRequest = z.object({
    cancellation_reason: z.string().nullish()
});

export const zCancelOrderRequest = z.object({
    cancellation_reason: z.string().nullish()
});

/**
 * An ECG or echo's measurements.
 */
export const zCardiologyMeasurementsResponse = z.object({
    ejection_fraction: z.number().nullish(),
    heart_rate: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    pr_interval: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    qrs_duration: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    qt_interval: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    qtc_interval: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    study_type: z.string().nullish()
});

export const zCcdaImportEntryResponse = z.object({
    code: z.string().nullish(),
    code_system: z.string().nullish(),
    details: z.unknown(),
    display: z.string().nullish(),
    entry_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    import_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    merged_native_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    narrative: z.string().nullish(),
    onset_date: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    reviewed_at: z.iso.datetime().nullish(),
    reviewed_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    section: z.string(),
    status: z.string(),
    status_text: z.string().nullish()
});

export const zCcdaImportResponse = z.object({
    blob_resource_id: z.string().nullish(),
    doc_type: z.string(),
    entry_count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    import_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    pending_count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    received_at: z.iso.datetime(),
    received_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    record_mismatch: z.boolean(),
    status: z.string()
});

export const zCcdaImportDetailResponse = zCcdaImportResponse.and(z.object({
    entries: z.array(zCcdaImportEntryResponse)
}));

export const zCcdaImportListResponse = z.object({
    data: z.array(zCcdaImportResponse),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    total: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    total_pages: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zCdsOrderAlert = z.object({
    alert_type: z.string(),
    message: z.string(),
    severity: z.string(),
    source: z.string(),
    title: z.string()
});

export const zChangePasswordRequest = z.object({
    current_password: z.string(),
    new_password: z.string()
});

export const zChargeMasterResponse = z.object({
    charge_category: z.string().nullish(),
    charge_code: z.string(),
    charge_description: z.string(),
    charge_master_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    cost_center: z.string().nullish(),
    cpt_code: z.string().nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    hcpcs_code: z.string().nullish(),
    is_active: z.boolean(),
    medicaid_charge: z.number().nullish(),
    medicare_charge: z.number().nullish(),
    revenue_code: z.string().nullish(),
    standard_charge: z.number()
});

export const zChargeResponse = z.object({
    charge_code: z.string(),
    charge_description: z.string(),
    charge_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    charge_status: z.string(),
    charge_type: z.string(),
    created_at: z.iso.datetime(),
    currency: z.string(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_active: z.boolean(),
    ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ordering_provider_name: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    service_date: z.iso.datetime(),
    total_amount: z.number(),
    unit_price: z.number()
});

/**
 * The registration desk's capture. Every field optional: a desk that only
 * confirms the patient is here sends an empty body, which is what a kiosk does.
 */
export const zCheckInRequest = z.object({
    authorization_number: z.string().nullish(),
    authorization_verified: z.boolean().nullish(),
    copay_amount: z.string(),
    copay_collected: z.boolean().nullish(),
    insurance_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zClaimResponse = z.object({
    adjudicated_date: z.iso.datetime().nullish(),
    claim_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    claim_number: z.string(),
    claim_status: z.string(),
    claim_type: z.string(),
    created_at: z.iso.datetime(),
    currency: z.string(),
    denial_reason: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_active: z.boolean(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    patient_responsibility: z.number().nullish(),
    payer_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    payer_name: z.string().nullish(),
    service_date_from: z.iso.datetime().nullish(),
    service_date_to: z.iso.datetime().nullish(),
    submitted_date: z.iso.datetime().nullish(),
    total_allowed_amount: z.number().nullish(),
    total_charge_amount: z.number(),
    total_paid_amount: z.number().nullish()
});

/**
 * Ask for an encounter's class to change.
 */
export const zClassChangeRequest = z.object({
    reason: z.string(),
    target_class: z.string()
});

/**
 * What happened, and whether it is waiting on a second signature.
 */
export const zClassChangeResponse = z.object({
    adt_event: z.string(),
    applied: z.boolean(),
    from_class: z.string(),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    pending_reason: z.string().nullish(),
    to_class: z.string()
});

/**
 * One recorded class change.
 */
export const zClassHistoryEntry = z.object({
    concurred_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    effective_datetime: z.iso.datetime(),
    encounter_class_history_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    from_class: z.string(),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    ordered_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    reason: z.string().nullish(),
    to_class: z.string()
});

/**
 * Client connection status
 */
export const zClientStatus = z.object({
    endpoint: z.string(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    interface_name: z.string(),
    is_connected: z.boolean(),
    last_activity: z.iso.datetime().nullish(),
    reconnect_attempts: z.int().gte(0).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    total_messages_sent: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zClientListResponse = z.object({
    clients: z.array(zClientStatus),
    count: z.int().gte(0)
});

export const zClinicalNoteResponse = z.object({
    amendment_reason: z.string().nullish(),
    assessment: z.string().nullish(),
    author_name: z.string().nullish(),
    author_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    chief_complaint: z.string().nullish(),
    content: z.string(),
    copied_from_note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    cosigned_at: z.string().nullish(),
    cosigned_by_name: z.string().nullish(),
    cosigned_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    created_at: z.string(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    history_present_illness: z.string().nullish(),
    modified_at: z.string().nullish(),
    note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    note_type: z.string(),
    parent_note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    past_medical_history: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    physical_exam: z.string().nullish(),
    plan: z.string().nullish(),
    review_of_systems: z.string().nullish(),
    signed_at: z.string().nullish(),
    signed_by_name: z.string().nullish(),
    signed_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    status: z.string(),
    title: z.string()
});

/**
 * Patient entity - core patient demographics (APAC-optimized)
 * One coded demographic value -- a race or an ethnicity.
 *
 * snake_case like every other backend struct; the axios interceptor converts to
 * camelCase at the frontend boundary (Critical Rule 2).
 *
 * `system` names the value set the code belongs to, so the vocabulary is chosen
 * per jurisdiction rather than compiled in. `code` is absent for an uncoded
 * value -- every value migrated from the old single-valued columns -- while
 * `display` is always present, so an uncoded value still renders and still
 * exports as valid US Core (whose `text` sub-extension is 1..1 and whose codes
 * are optional).
 */
export const zCodedDemographic = z.object({
    code: z.string().nullish(),
    display: z.string(),
    ordinal: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    system: z.string()
});

export const zCosignNoteRequest = z.object({
    cosigned_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateAppRequest = z.object({
    allowed_facility_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })).nullish(),
    app_category: z.string(),
    app_code: z.string(),
    app_name: z.string(),
    base_url: z.string(),
    display_in_chart: z.boolean().nullish(),
    display_in_sidebar: z.boolean().nullish(),
    display_order: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    encryption_algorithm: z.string().nullish(),
    encryption_enabled: z.boolean().nullish(),
    encryption_key: z.string().nullish(),
    icon_name: z.string().nullish(),
    launch_method: z.string().nullish(),
    parameter_mappings: z.unknown().optional(),
    required_permission: z.string().nullish(),
    signature_enabled: z.boolean().nullish(),
    signature_key: z.string().nullish()
});

export const zCreateAppointmentRequest = z.object({
    appointment_datetime: z.iso.datetime(),
    appointment_type: z.string(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    reason: z.string().nullish()
});

export const zCreateCategoryRequest = z.object({
    audit_level: z.string().nullish(),
    category_code: z.string(),
    category_description: z.string().nullish(),
    category_name: z.string(),
    display_order: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    max_failed_logins: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    max_session_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    mfa_required: z.boolean().nullish(),
    password_expiry_days: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

export const zCreateChargeRequest = z.object({
    charge_code: z.string(),
    charge_description: z.string().nullish(),
    currency: z.string().nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    service_date: z.iso.datetime().nullish(),
    unit_price: z.number()
});

export const zCreateClaimRequest = z.object({
    charge_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    claim_type: z.string(),
    diagnosis_codes: z.array(z.string()).optional(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    payer_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    service_date_from: z.iso.datetime().nullish(),
    service_date_to: z.iso.datetime().nullish()
});

export const zCreateClientRequest = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateEncounterRequest = z.object({
    acuity_level: z.string().nullish(),
    admission_source: z.string().nullish(),
    admission_type: z.string().nullish(),
    attending_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    chief_complaint: z.string().nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_class: z.string().nullish(),
    encounter_type: z.string().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_international_patient: z.boolean().nullish(),
    patient_home_country: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    translator_language: z.string().nullish(),
    translator_required: z.boolean().nullish(),
    visit_reason: z.string().nullish()
});

/**
 * Create HL7 Message request
 */
export const zCreateHl7MessageRequest = z.object({
    correlation_id: z.string().nullish(),
    message_raw: z.string(),
    source_system: z.string().nullish()
});

/**
 * Request to create an HoH client connection
 */
export const zCreateHohClientRequest = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateMedicationRequest = z.object({
    administration_instructions: z.string().nullish(),
    allow_substitution: z.boolean().nullish(),
    clinical_indication: z.string().nullish(),
    dose: z.string(),
    dose_override_reason: z.string().nullish(),
    dose_unit: z.string().nullish(),
    duration: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    duration_unit: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    frequency_code: z.string(),
    frequency_description: z.string().nullish(),
    generic_name: z.string().nullish(),
    indication: z.string().nullish(),
    is_prn: z.boolean().nullish(),
    medication_catalog_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    medication_name: z.string(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_instructions: z.string().nullish(),
    pharmacy_notes: z.string().nullish(),
    pregnancy_override_reason: z.string().nullish(),
    priority: z.string().nullish(),
    prn_indication: z.string().nullish(),
    quantity_dispensed: z.number().nullish(),
    refills_authorized: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    renal_override_reason: z.string().nullish(),
    route: z.string(),
    total_doses: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    unscreened_override_reason: z.string().nullish()
});

export const zCreateNoteRequest = z.object({
    assessment: z.string().nullish(),
    chief_complaint: z.string().nullish(),
    content: z.string(),
    copied_from_note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    cosign_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    cosign_required: z.boolean().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    history_present_illness: z.string().nullish(),
    note_type: z.string(),
    past_medical_history: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    physical_exam: z.string().nullish(),
    plan: z.string().nullish(),
    review_of_systems: z.string().nullish(),
    title: z.string()
});

export const zCreateOrderRequest = z.object({
    body_site: z.string().nullish(),
    clinical_indication: z.string().nullish(),
    diagnosis_code: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    instructions: z.string().nullish(),
    is_verbal_order: z.boolean().nullish(),
    laterality: z.string().nullish(),
    order_catalog_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    order_description: z.string().nullish(),
    order_name: z.string(),
    order_type: z.string(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_instructions: z.string().nullish(),
    priority: z.string().nullish(),
    scheduled_datetime: z.iso.datetime().nullish(),
    special_instructions: z.string().nullish(),
    unscreened_override_reason: z.string().nullish()
});

export const zCreatePatientRequest = z.object({
    address_line1: z.string().nullish(),
    address_line2: z.string().nullish(),
    alternative_name: z.string().nullish(),
    birth_time: z.string().nullish(),
    city: z.string().nullish(),
    country: z.string().nullish(),
    date_of_birth: z.iso.date(),
    duplicate_override_reason: z.string().nullish(),
    email: z.string().nullish(),
    ethnicity: z.array(zCodedDemographic).optional(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    first_name: z.string().nullish(),
    full_name: z.string(),
    gender_legal: z.string(),
    interpreter_required: z.boolean().nullish(),
    is_medical_tourist: z.boolean().nullish(),
    is_vip: z.boolean().nullish(),
    last_name: z.string().nullish(),
    mobile_phone: z.string().nullish(),
    national_id_number: z.string().nullish(),
    national_id_type: z.string().nullish(),
    postal_code: z.string().nullish(),
    preferred_name: z.string().nullish(),
    primary_language: z.string().nullish(),
    primary_phone: z.string().nullish(),
    race: z.array(zCodedDemographic).optional(),
    sex_at_birth: z.string().nullish()
});

export const zCreatePaymentRequest = z.object({
    amount: z.number(),
    claim_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    currency: z.string().nullish(),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    payment_method: z.string(),
    payment_type: z.string(),
    reference_number: z.string().nullish()
});

export const zCreatePermissionRequest = z.object({
    action: z.string().nullish(),
    description: z.string().nullish(),
    permission_code: z.string(),
    permission_name: z.string(),
    resource: z.string().nullish()
});

export const zCreateResultRequest = z.object({
    clinical_significance: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    impression: z.string().nullish(),
    interpreted_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_critical: z.boolean().nullish(),
    is_panic_value: z.boolean().nullish(),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    pathologist_notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    performing_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    radiologist_notes: z.string().nullish(),
    recommendations: z.string().nullish(),
    report_text: z.string().nullish(),
    result_code: z.string().nullish(),
    result_code_system: z.string().nullish(),
    result_name: z.string().nullish(),
    result_type: z.string(),
    specimen_collection_datetime: z.iso.datetime().nullish(),
    technician_notes: z.string().nullish(),
    verified_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zCreateReviewCampaignRequest = z.object({
    due_date: z.iso.date().nullish(),
    name: z.string().nullish()
});

export const zCreateRoleRequest = z.object({
    category_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    parent_role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_code: z.string(),
    role_description: z.string().nullish(),
    role_name: z.string()
});

export const zCreateScheduleTemplateRequest = z.object({
    appointment_duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    day_of_week: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    effective_end_date: z.string().nullish(),
    effective_start_date: z.string(),
    end_time: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    start_time: z.string(),
    template_name: z.string()
});

export const zCreateSmartAppRequest = z.object({
    launch_url: z.string().nullish(),
    logo_url: z.string().nullish(),
    name: z.string(),
    redirect_uris: z.array(z.string()),
    scopes: z.array(z.string())
});

export const zCreateSmartPhraseRequest = z.object({
    category: z.string().nullish(),
    created_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    expansion_text: z.string(),
    phrase_key: z.string()
});

export const zCreateSsoDirectoryRequest = z.object({
    base_dn: z.string(),
    bind_dn: z.string().optional(),
    bind_password: z.string().optional(),
    ca_pem: z.string().optional(),
    enabled: z.boolean().optional(),
    group_attribute: z.string().optional(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    host: z.string(),
    name: z.string(),
    name_attribute: z.string().optional(),
    port: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    tls_mode: z.string().optional(),
    tls_verify: z.boolean().optional(),
    user_filter: z.string()
});

export const zCreateSsoDomainRequest = z.object({
    domain: z.string(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateSsoGroupMapRequest = z.object({
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    group_value: z.string(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateSsoLdapMapRequest = z.object({
    directory_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ldap_group: z.string(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateSsoProviderRequest = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    enabled: z.boolean().optional(),
    group_claim: z.string().optional(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    idp_metadata: z.string().optional(),
    issuer: z.string(),
    name: z.string(),
    provider: z.string()
});

export const zCreateTemplateRequest = z.object({
    content: z.string(),
    note_type: z.string(),
    sections: z.array(z.string()).nullish(),
    specialty: z.string().nullish(),
    template_name: z.string()
});

export const zCreateUserGroupRequest = z.object({
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_active: z.boolean(),
    name: z.string()
});

export const zDashboardWidget = z.object({
    config: z.unknown().optional(),
    height: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    position_x: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    position_y: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    report_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    title: z.string(),
    widget_id: z.string(),
    widget_type: z.string(),
    width: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zCreateDashboardRequest = z.object({
    dashboard_name: z.string(),
    description: z.string().nullish(),
    is_shared: z.boolean().nullish(),
    layout: z.string().nullish(),
    widgets: z.array(zDashboardWidget).nullish()
});

export const zDashboardResponse = z.object({
    created_at: z.iso.datetime(),
    dashboard_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    dashboard_name: z.string(),
    description: z.string().nullish(),
    is_active: z.boolean(),
    is_default: z.boolean(),
    is_shared: z.boolean(),
    layout: z.string(),
    modified_at: z.iso.datetime().nullish(),
    owner_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    owner_name: z.string().nullish(),
    widgets: z.array(zDashboardWidget)
});

export const zDeadLetterEntry = z.object({
    attempts: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    created_at: z.string(),
    dead_letter_at: z.string(),
    event_type: z.string(),
    last_error: z.string().nullish(),
    outbox_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    payload: z.record(z.string(), z.unknown()),
    stream: z.string()
});

/**
 * Provider/directory delete answer: the logins survive (unlinked), and
 * `users_kept` says how many stayed (the VynaECG delete shape).
 */
export const zDeleteKeptResponse = z.object({
    deleted: z.boolean(),
    users_kept: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zDeleteUserGroupResponse = z.object({
    deleted: z.boolean(),
    roles_retracted: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zDenialItem = z.object({
    amount: z.number(),
    assigned_to: z.string(),
    claim_number: z.string(),
    days_remaining: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    denial_code: z.string().nullish(),
    denial_date: z.iso.date(),
    denial_reason: z.string().nullish(),
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    priority: z.string(),
    status: z.string()
});

export const zDenialsResponse = z.object({
    data: z.array(zDenialItem)
});

export const zDeniedPermissionEntry = z.object({
    permission_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    reason: z.string().nullish()
});

export const zDeniedPermissionResponse = z.object({
    deny_reason: z.string().nullish(),
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    key: z.string(),
    label: z.string()
});

export const zDischargeRequest = z.object({
    discharge_destination: z.string().nullish(),
    discharge_diagnosis: z.string().nullish(),
    discharge_disposition: z.string().nullish(),
    discharge_notes: z.string().nullish(),
    follow_up_instructions: z.string().nullish()
});

export const zDiscontinueMedicationRequest = z.object({
    discontinuation_reason: z.string().nullish()
});

/**
 * One field on which the pharmacy's encoding differed from the order.
 */
export const zDiscrepancyFieldResponse = z.object({
    encoded_value: z.string().nullish(),
    field_name: z.string(),
    is_holding: z.boolean(),
    ordered_value: z.string().nullish()
});

/**
 * A detection event, with the fields that differed.
 */
export const zDiscrepancyResponse = z.object({
    detected_at: z.string().nullish(),
    discrepancy_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    fields: z.array(zDiscrepancyFieldResponse),
    held: z.boolean(),
    medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    resolution: z.string().nullish(),
    resolution_note: z.string().nullish(),
    resolved_at: z.string().nullish(),
    resolved_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zDismissRequest = z.object({
    notes: z.string().nullish(),
    reason: z.string()
});

export const zDismissResponse = z.object({
    candidate_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    review_status: z.string(),
    reviewed_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * One pharmacy dispensing event, FHIR R4 `MedicationDispense` shaped.
 *
 * Distinct from [`AdministrationResponse`]: a dispense is what the pharmacy
 * packed and handed over, an administration is what a nurse gave the patient.
 * One order has MANY dispenses -- partial fills and repeats.
 */
export const zDispenseResponse = z.object({
    created_at: z.string(),
    created_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    days_supply: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    destination: z.string().nullish(),
    dispense_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    dispense_type: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    external_dispense_id: z.string().nullish(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    medication_code: z.string().nullish(),
    medication_coding_system: z.string().nullish(),
    medication_name: z.string(),
    medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    note: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    performer_name: z.string().nullish(),
    quantity: z.string().nullish(),
    quantity_unit: z.string().nullish(),
    receiver_name: z.string().nullish(),
    source_message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    status: z.string(),
    substitution_reason: z.string().nullish(),
    was_substituted: z.boolean(),
    when_handed_over: z.string().nullish(),
    when_prepared: z.string().nullish()
});

/**
 * Optional witness credentials for the independent double-check.
 *
 * High-alert medications (insulin, anticoagulants, chemo) require a SECOND
 * nurse to verify drug and dose. The MAR used to fake this with a checkbox and
 * a free-text name, so `double_checked_by_user_id` stayed NULL — the column
 * every downstream audit actually reads.
 *
 * When both fields are present, THIS user is the verifier: authenticated
 * inline, with no session minted. Absent = today's behaviour (the caller is the
 * verifier), so no existing client breaks.
 * Unrecognised fields are rejected with 400 — supply exactly
 * `verifier_username` and `verifier_password`, or no body at all.
 */
export const zDoubleCheckRequest = z.object({
    verifier_password: z.string().nullish(),
    verifier_username: z.string().nullish()
});

export const zDuplicateCandidate = z.object({
    date_of_birth: z.iso.date(),
    full_name: z.string(),
    match_reasons: z.array(z.string()),
    match_score: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    mrn: z.string(),
    national_id_number: z.string().nullish(),
    national_id_type: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * The `POST /patients` 409 body: registration stopped by a confident match.
 */
export const zDuplicateBlockedResponse = z.object({
    block_kind: z.string(),
    candidates: z.array(zDuplicateCandidate),
    message: z.string(),
    overridable: z.boolean(),
    restricted_match_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * One side of a candidate pair. Enough to judge the match without opening
 * either chart.
 */
export const zDuplicatePatient = z.object({
    date_of_birth: z.iso.date(),
    full_name: z.string(),
    gender_legal: z.string(),
    mrn: z.string(),
    national_id_number: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zDuplicateCandidateRow = z.object({
    address_match: z.boolean(),
    candidate_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    detected_datetime: z.iso.datetime(),
    detection_method: z.string().nullish(),
    dob_match: z.boolean(),
    gender_match: z.boolean(),
    match_confidence: z.string().nullish(),
    name_match: z.boolean(),
    national_id_match: z.boolean(),
    patient_a: zDuplicatePatient,
    patient_b: zDuplicatePatient,
    phone_match: z.boolean(),
    review_status: z.string(),
    similarity_score: z.number().nullish()
});

/**
 * A non-blocking duplicate finding attached to a successful create.
 *
 * `kind` is machine-readable so the UI can tell "we found something weaker
 * than a block" from "we could not look".
 */
export const zDuplicateWarning = z.object({
    candidates: z.array(zDuplicateCandidate),
    kind: z.string(),
    message: z.string(),
    restricted_match_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    title: z.string()
});

export const zEffectivePermission = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_denied: z.boolean(),
    key: z.string(),
    label: z.string(),
    source: z.string()
});

export const zEmergencyContactSummary = z.object({
    name: z.string(),
    phone: z.string(),
    relationship: z.string()
});

export const zEncounterDiagnosisResponse = z.object({
    diagnosis_code: z.string(),
    diagnosis_description: z.string(),
    diagnosis_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    diagnosis_type: z.string(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_active: z.boolean(),
    rank: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zEncounterResponse = z.object({
    actual_end_datetime: z.iso.datetime().nullish(),
    actual_start_datetime: z.iso.datetime().nullish(),
    acuity_level: z.string().nullish(),
    admission_source: z.string().nullish(),
    admission_type: z.string().nullish(),
    admitting_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    attending_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    attending_provider_name: z.string().nullish(),
    chief_complaint: z.string().nullish(),
    clinical_trial_id: z.string().nullish(),
    consulting_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    current_location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    current_location_label: z.string().nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    discharge_destination: z.string().nullish(),
    discharge_disposition: z.string().nullish(),
    encounter_class: z.string(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    encounter_number: z.string(),
    encounter_status: z.string(),
    encounter_type: z.string().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    fall_risk_level: z.string().nullish(),
    financial_class: z.string().nullish(),
    is_active: z.boolean(),
    is_clinical_trial: z.boolean(),
    is_international_patient: z.boolean(),
    is_observation: z.boolean(),
    is_readmission: z.boolean(),
    isolation_status: z.string().nullish(),
    length_of_stay_days: z.number().nullish(),
    patient_home_country: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_mrn: z.string().nullish(),
    patient_name: z.string().nullish(),
    pressure_injury_risk: z.string().nullish(),
    readmission_within_days: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    referring_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    scheduled_start_datetime: z.iso.datetime().nullish(),
    service_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    translator_language: z.string().nullish(),
    translator_required: z.boolean(),
    visit_reason: z.string().nullish()
});

export const zErrorResponse = z.object({
    error: z.string(),
    message: z.string()
});

export const zExpandSmartPhraseRequest = z.object({
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    phrase_key: z.string()
});

export const zExpandSmartPhraseResponse = z.object({
    expanded_text: z.string()
});

export const zExportFile = z.object({
    count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    type: z.string(),
    url: z.string()
});

export const zExportStatusResponse = z.object({
    error: z.array(zExportFile),
    jobId: z.string(),
    output: z.array(zExportFile),
    request: z.string(),
    requiresAccessToken: z.boolean(),
    status: z.string(),
    transactTime: z.string().nullish()
});

export const zFhirBundleLink = z.object({
    relation: z.string(),
    url: z.string()
});

export const zFhirBundle = z.object({
    entry: z.array(z.unknown()),
    link: z.array(zFhirBundleLink),
    resourceType: z.string(),
    total: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    type: z.string()
});

export const zFhirIssue = z.object({
    code: z.string(),
    diagnostics: z.string().nullish(),
    severity: z.string()
});

export const zFhirOperationOutcome = z.object({
    issue: z.array(zFhirIssue),
    resourceType: z.string()
});

export const zGenerateStatementRequest = z.object({
    date_from: z.iso.date().nullish(),
    date_to: z.iso.date().nullish(),
    include_paid: z.boolean().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Filter criteria for HL7 message queries
 */
export const zHl7MessageFilter = z.object({
    from_datetime: z.iso.datetime().nullish(),
    limit: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    message_event: z.string().nullish(),
    message_type: z.string().nullish(),
    offset: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    processing_status: z.string().nullish(),
    source_system: z.string().nullish(),
    to_datetime: z.iso.datetime().nullish()
});

/**
 * HL7 Message response for API
 */
export const zHl7MessageResponse = z.object({
    acknowledgment_code: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    error_message: z.string().nullish(),
    message_control_id: z.string(),
    message_event: z.string(),
    message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    message_type: z.string(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    processed_datetime: z.iso.datetime().nullish(),
    processing_status: z.string(),
    received_datetime: z.iso.datetime()
});

/**
 * Statistics for HL7 message processing
 */
export const zHl7MessageStats = z.object({
    avg_processing_time_ms: z.number().nullish(),
    pending_in_queue: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    total_errors: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    total_processed: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    total_received: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    total_rejected: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * HoH Client connection status
 */
export const zHohClientStatus = z.object({
    endpoint: z.string(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    interface_name: z.string(),
    last_activity: z.iso.datetime().nullish(),
    total_messages_sent: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * HoH Server runtime status
 */
export const zHohServerStatus = z.object({
    bind_address: z.string(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    interface_name: z.string(),
    started_at: z.iso.datetime(),
    total_messages_received: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * What a radiology report points at.
 */
export const zImagingStudyResponse = z.object({
    accession_number: z.string().nullish(),
    body_region: z.string().nullish(),
    study_instance_uid: z.string().nullish()
});

export const zImmunizationSummary = z.object({
    administered_date: z.iso.date().nullish(),
    dose_number: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    immunization_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    vaccine_name: z.string()
});

/**
 * Admin-facing projection of a VynaLinkIntegration row. TLS secrets
 * are redacted to booleans — the admin UI shows "configured / not
 * configured" and lets the user paste fresh PEM blobs to replace
 * them, never reads back what's on the row.
 */
export const zIntegrationResponse = z.object({
    app_nak_retry_max: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    auth_method: z.string(),
    auth_username: z.string().nullish(),
    created_at: z.iso.datetime(),
    description: z.string().nullish(),
    direction: z.string(),
    error_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    has_auth_secret: z.boolean(),
    has_ca: z.boolean(),
    has_cert: z.boolean(),
    has_key: z.boolean(),
    host: z.string().nullish(),
    inbound_ack_policy: z.string(),
    inbound_trust_profile: z.string().nullish(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_active: z.boolean(),
    last_error: z.string().nullish(),
    last_message: z.iso.datetime().nullish(),
    message_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    modified_at: z.iso.datetime(),
    name: z.string(),
    network_retry_max: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    outbound_ack_policy: z.string(),
    outbound_subscriptions: z.array(z.string()).nullish(),
    pending_ack_ttl_secs: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    port: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    processing_timeout_ms: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    receiving_application: z.string().nullish(),
    receiving_facility: z.string().nullish(),
    reverse_integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    status: z.string(),
    tls_enabled: z.boolean(),
    type: z.string(),
    url: z.string()
});

export const zIntegrationListResponse = z.object({
    data: z.array(zIntegrationResponse)
});

export const zIntegrationStats = z.object({
    awaiting_app_ack: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    backlog: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    failed_blocking: z.boolean(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    oldest_pending_secs: z.number().nullish()
});

/**
 * API response for integration status
 */
export const zIntegrationStatusResponse = z.object({
    connection_status: z.string(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    interface_name: z.string(),
    interface_type: z.string(),
    is_running: z.boolean(),
    last_heartbeat: z.iso.datetime().nullish(),
    messages_failed: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    messages_received: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    messages_sent: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

/**
 * One analyte within a laboratory report.
 *
 * The laboratory's own interpretation rides along. It knows its assay, its
 * analyser and its population; a reader that recomputed abnormality from the
 * reference range would be overriding it with arithmetic.
 */
export const zLabComponentResponse = z.object({
    abnormal_flag: z.string().nullish(),
    component_code: z.string(),
    component_name: z.string(),
    delta_flag: z.string().nullish(),
    is_abnormal: z.boolean(),
    is_critical: z.boolean(),
    reference_range_high: z.number().nullish(),
    reference_range_low: z.number().nullish(),
    reference_range_text: z.string().nullish(),
    result_unit: z.string().nullish(),
    result_value: z.string().nullish(),
    result_value_numeric: z.number().nullish()
});

export const zLaunchRequest = z.object({
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    order_number: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zLaunchResponse = z.object({
    launch_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    launch_method: z.string(),
    url: z.string()
});

/**
 * One enabled directory, as the login page lists it. Names the
 * directory — never hosts, secrets, filters, or user data.
 * Deliberately no `health_system_id`: the picker never uses it, and
 * this list is public pre-auth — every field here is enumerable.
 */
export const zLdapDirectoryInfo = z.object({
    directory_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    name: z.string()
});

export const zLdapLoginRequest = z.object({
    directory_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    mfa_code: z.string().nullish(),
    password: z.string(),
    username: z.string()
});

/**
 * Test-leg answer: ALWAYS 200 — `ok` carries the verdict (the VynaECG
 * shape), so an unreachable directory is data, not an HTTP error.
 */
export const zLdapTestResult = z.object({
    detail: z.string(),
    ok: z.boolean()
});

export const zLoginRequest = z.object({
    mfa_code: z.string().nullish(),
    password: z.string(),
    username: z.string()
});

export const zMarScheduleEntry = z.object({
    administrations: z.array(zAdministrationResponse),
    dose: z.string(),
    frequency: z.string(),
    medication_name: z.string(),
    medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    route: z.string(),
    scheduled_times: z.array(z.string())
});

export const zMarScheduleResponse = z.object({
    date: z.string(),
    entries: z.array(zMarScheduleEntry),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * A no-show is not a cancellation — see `mark_no_show`.
 */
export const zMarkNoShowRequest = z.object({
    note: z.string().nullish()
});

export const zMatchParameter = z.object({
    name: z.string(),
    resource: z.unknown().optional(),
    valueBoolean: z.boolean().nullish(),
    valueInteger: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zMatrixDenied = z.object({
    permission_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zMatrixGrant = z.object({
    permission_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    source: z.string()
});

export const zMatrixPermissionInfo = z.object({
    category_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    key: z.string(),
    label: z.string(),
    resource_type: z.string()
});

export const zMedicationResponse = z.object({
    administration_instructions: z.string().nullish(),
    allergy_checked: z.boolean(),
    allow_substitution: z.boolean(),
    continue_at_discharge: z.boolean().nullish(),
    dea_schedule: z.string().nullish(),
    dose: z.string(),
    dose_range_checked: z.boolean(),
    dose_unit: z.string().nullish(),
    double_checked: z.boolean(),
    duplicate_therapy_checked: z.boolean(),
    duration: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    duration_unit: z.string().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    frequency_code: z.string(),
    frequency_description: z.string().nullish(),
    generic_name: z.string().nullish(),
    indication: z.string().nullish(),
    interaction_checked: z.boolean(),
    is_active: z.boolean(),
    is_controlled: z.boolean(),
    is_high_alert: z.boolean(),
    is_home_medication: z.boolean(),
    is_prn: z.boolean(),
    medication_catalog_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    medication_name: z.string(),
    medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    ndc_code: z.string().nullish(),
    off_label_use: z.boolean(),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    order_number: z.string().nullish(),
    order_status: z.string(),
    ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ordering_provider_name: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_instructions: z.string().nullish(),
    patient_mrn: z.string().nullish(),
    patient_name: z.string().nullish(),
    pharmacist_verification_required: z.boolean(),
    pharmacist_verified: z.boolean(),
    pharmacy_notes: z.string().nullish(),
    priority: z.string(),
    prn_indication: z.string().nullish(),
    quantity_dispensed: z.number().nullish(),
    refills_authorized: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    requires_double_check: z.boolean(),
    route: z.string(),
    screened_allergy: z.boolean(),
    screened_dose_range: z.boolean(),
    screened_duplicate_therapy: z.boolean(),
    screened_interaction: z.boolean(),
    substitution_reason: z.string().nullish(),
    total_doses: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    verified_by_pharmacist_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    verified_datetime: z.iso.datetime().nullish()
});

export const zMedicationSummary = z.object({
    dosage: z.string().nullish(),
    frequency: z.string().nullish(),
    medication_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    medication_name: z.string(),
    start_date: z.iso.date().nullish()
});

/**
 * The `POST /medications` 201 body: the created record plus the non-blocking
 * CDS warnings raised while prescribing it.
 *
 * Returned on EVERY create — `cds_alerts` is `[]` when the create is clean.
 * One documented shape (never flat-or-wrapped), so the OpenAPI spec and the FE
 * Zod schema cannot drift from the runtime body. The warning is a fact about
 * the act of prescribing, not a column on the persisted row, so it rides
 * beside the record rather than being folded into it — `list`/`get`/`verify`/
 * `discontinue` keep returning the flat `MedicationResponse`. Mirrors
 * `orders::OrderWithCdsResponse`.
 */
export const zMedicationWithCdsResponse = z.object({
    cds_alerts: z.array(zCdsOrderAlert),
    medication: zMedicationResponse
});

export const zMessageResponse = z.object({
    message: z.string()
});

export const zMessageSummary = z.object({
    ack_code: z.string().nullish(),
    attempt_count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    created_at: z.iso.datetime(),
    direction: z.string(),
    from_archive: z.boolean(),
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    message_control_id: z.string(),
    message_type: z.string(),
    status: z.string()
});

export const zMessageDetail = z.object({
    ack_text: z.string().nullish(),
    last_error: z.string().nullish(),
    next_retry_at: z.iso.datetime().nullish(),
    raw_message: z.string().nullish(),
    received_at: z.iso.datetime().nullish(),
    source_event_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    summary: zMessageSummary
});

export const zMessageListResponse = z.object({
    page: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    page_size: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    rows: z.array(zMessageSummary),
    total: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zMfaRequiredResponse = z.object({
    error: z.string(),
    message: z.string(),
    mfa_required: z.boolean(),
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * The login 401, both shapes it can send: `ErrorResponse` for bad
 * credentials and `MfaRequiredResponse` for the MFA challenge.
 *
 * Docs-only — the handler builds both bodies by hand
 * (`map_login_auth_error`), and utoipa keeps only one `body` per status
 * code, so a second 401 entry would silently overwrite the first. The
 * untagged enum renders as `anyOf` with both refs, which is what generated
 * clients need to handle the challenge.
 */
export const zLoginUnauthorizedResponse = z.union([
    zErrorResponse,
    zMfaRequiredResponse
]);

/**
 * Mint request: which health system the token provisions, and the
 * human label shown beside its prefix in the admin list.
 */
export const zMintScimTokenRequest = z.object({
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    label: z.string()
});

export const zNoteTemplateResponse = z.object({
    content: z.string(),
    created_at: z.string(),
    is_active: z.boolean(),
    note_type: z.string(),
    sections: z.array(z.string()),
    specialty: z.string().nullish(),
    template_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    template_name: z.string()
});

export const zOrderResponse = z.object({
    authorization_number: z.string().nullish(),
    authorization_status: z.string().nullish(),
    body_site: z.string().nullish(),
    clinical_indication: z.string().nullish(),
    completed_datetime: z.iso.datetime().nullish(),
    diagnosis_code: z.string().nullish(),
    discontinuation_reason: z.string().nullish(),
    discontinued_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    discontinued_datetime: z.iso.datetime().nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    external_order_id: z.string().nullish(),
    external_ordering_provider_name: z.string().nullish(),
    has_results: z.boolean(),
    hl7_message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    instructions: z.string().nullish(),
    is_active: z.boolean(),
    laterality: z.string().nullish(),
    order_catalog_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    order_description: z.string().nullish(),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    order_name: z.string(),
    order_number: z.string(),
    order_status: z.string(),
    order_type: z.string(),
    ordered_datetime: z.iso.datetime(),
    ordering_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    ordering_provider_name: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_instructions: z.string().nullish(),
    patient_mrn: z.string().nullish(),
    patient_name: z.string().nullish(),
    performing_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    performing_location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    performing_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    priority: z.string(),
    scheduled_datetime: z.iso.datetime().nullish(),
    source_system: z.string().nullish(),
    special_instructions: z.string().nullish(),
    start_datetime: z.iso.datetime().nullish()
});

/**
 * Response returned when an order is created with CDS warnings (non-blocking)
 */
export const zOrderWithCdsResponse = z.object({
    cds_alerts: z.array(zCdsOrderAlert),
    order: zOrderResponse
});

/**
 * Proceed without pharmacist verification. Both fields are required — see
 * [`override_verification`].
 */
export const zOverrideVerificationRequest = z.object({
    justification: z.string(),
    reason_code: z.string()
});

export const zPagination = z.object({
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    total: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    total_pages: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

/**
 * The worklist, plus what it is not showing you.
 *
 * `data` and `pagination` keep the shape `PaginatedResponse` produced, so this
 * is additive on the wire.
 */
export const zDuplicateWorklistResponse = z.object({
    data: z.array(zDuplicateCandidateRow),
    pagination: zPagination,
    restricted_pair_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zPaginatedResponseAdministrationResponse = z.object({
    data: z.array(z.object({
        administered_at: z.string(),
        administered_by_name: z.string(),
        administered_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        administration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        barcode_scanned: z.boolean(),
        created_at: z.string(),
        dose_given: z.string(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        hold_reason: z.string().nullish(),
        medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        notes: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        route: z.string(),
        site: z.string().nullish(),
        status: z.string()
    })),
    pagination: zPagination
});

export const zPaginatedResponseAppointmentResponse = z.object({
    data: z.array(z.object({
        appointment_datetime: z.iso.datetime(),
        appointment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        appointment_number: z.string(),
        appointment_type: z.string(),
        arrival_datetime: z.iso.datetime().nullish(),
        arrived: z.boolean().nullish(),
        authorization_number: z.string().nullish(),
        authorization_verified: z.boolean().nullish(),
        cancellation_reason: z.string().nullish(),
        check_in_time: z.iso.datetime().nullish(),
        copay_amount: z.string().nullish(),
        copay_collected: z.boolean().nullish(),
        created_at: z.iso.datetime(),
        department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        end_datetime: z.iso.datetime().nullish(),
        external_appointment_id: z.string().nullish(),
        external_provider_name: z.string().nullish(),
        facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        hl7_message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        insurance_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        modified_at: z.iso.datetime().nullish(),
        mrn: z.string().nullish(),
        notes: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_name: z.string().nullish(),
        provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        provider_name: z.string().nullish(),
        reason: z.string().nullish(),
        room_number: z.string().nullish(),
        source_system: z.string().nullish(),
        status: z.string()
    })),
    pagination: zPagination
});

export const zPaginatedResponseChargeMasterResponse = z.object({
    data: z.array(z.object({
        charge_category: z.string().nullish(),
        charge_code: z.string(),
        charge_description: z.string(),
        charge_master_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        cost_center: z.string().nullish(),
        cpt_code: z.string().nullish(),
        department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        hcpcs_code: z.string().nullish(),
        is_active: z.boolean(),
        medicaid_charge: z.number().nullish(),
        medicare_charge: z.number().nullish(),
        revenue_code: z.string().nullish(),
        standard_charge: z.number()
    })),
    pagination: zPagination
});

export const zPaginatedResponseChargeResponse = z.object({
    data: z.array(z.object({
        charge_code: z.string(),
        charge_description: z.string(),
        charge_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        charge_status: z.string(),
        charge_type: z.string(),
        created_at: z.iso.datetime(),
        currency: z.string(),
        department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        is_active: z.boolean(),
        ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        ordering_provider_name: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_name: z.string().nullish(),
        quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
        service_date: z.iso.datetime(),
        total_amount: z.number(),
        unit_price: z.number()
    })),
    pagination: zPagination
});

export const zPaginatedResponseClaimResponse = z.object({
    data: z.array(z.object({
        adjudicated_date: z.iso.datetime().nullish(),
        claim_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        claim_number: z.string(),
        claim_status: z.string(),
        claim_type: z.string(),
        created_at: z.iso.datetime(),
        currency: z.string(),
        denial_reason: z.string().nullish(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        is_active: z.boolean(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_name: z.string().nullish(),
        patient_responsibility: z.number().nullish(),
        payer_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        payer_name: z.string().nullish(),
        service_date_from: z.iso.datetime().nullish(),
        service_date_to: z.iso.datetime().nullish(),
        submitted_date: z.iso.datetime().nullish(),
        total_allowed_amount: z.number().nullish(),
        total_charge_amount: z.number(),
        total_paid_amount: z.number().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponseClinicalNoteResponse = z.object({
    data: z.array(z.object({
        amendment_reason: z.string().nullish(),
        assessment: z.string().nullish(),
        author_name: z.string().nullish(),
        author_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        chief_complaint: z.string().nullish(),
        content: z.string(),
        copied_from_note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        cosigned_at: z.string().nullish(),
        cosigned_by_name: z.string().nullish(),
        cosigned_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        created_at: z.string(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        history_present_illness: z.string().nullish(),
        modified_at: z.string().nullish(),
        note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        note_type: z.string(),
        parent_note_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        past_medical_history: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        physical_exam: z.string().nullish(),
        plan: z.string().nullish(),
        review_of_systems: z.string().nullish(),
        signed_at: z.string().nullish(),
        signed_by_name: z.string().nullish(),
        signed_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        status: z.string(),
        title: z.string()
    })),
    pagination: zPagination
});

export const zPaginatedResponseDashboardResponse = z.object({
    data: z.array(z.object({
        created_at: z.iso.datetime(),
        dashboard_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        dashboard_name: z.string(),
        description: z.string().nullish(),
        is_active: z.boolean(),
        is_default: z.boolean(),
        is_shared: z.boolean(),
        layout: z.string(),
        modified_at: z.iso.datetime().nullish(),
        owner_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        owner_name: z.string().nullish(),
        widgets: z.array(zDashboardWidget)
    })),
    pagination: zPagination
});

export const zPaginatedResponseDuplicateCandidateRow = z.object({
    data: z.array(z.object({
        address_match: z.boolean(),
        candidate_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        detected_datetime: z.iso.datetime(),
        detection_method: z.string().nullish(),
        dob_match: z.boolean(),
        gender_match: z.boolean(),
        match_confidence: z.string().nullish(),
        name_match: z.boolean(),
        national_id_match: z.boolean(),
        patient_a: zDuplicatePatient,
        patient_b: zDuplicatePatient,
        phone_match: z.boolean(),
        review_status: z.string(),
        similarity_score: z.number().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponseEncounterResponse = z.object({
    data: z.array(z.object({
        actual_end_datetime: z.iso.datetime().nullish(),
        actual_start_datetime: z.iso.datetime().nullish(),
        acuity_level: z.string().nullish(),
        admission_source: z.string().nullish(),
        admission_type: z.string().nullish(),
        admitting_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        attending_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        attending_provider_name: z.string().nullish(),
        chief_complaint: z.string().nullish(),
        clinical_trial_id: z.string().nullish(),
        consulting_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        current_location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        current_location_label: z.string().nullish(),
        department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        discharge_destination: z.string().nullish(),
        discharge_disposition: z.string().nullish(),
        encounter_class: z.string(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        encounter_number: z.string(),
        encounter_status: z.string(),
        encounter_type: z.string().nullish(),
        facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        fall_risk_level: z.string().nullish(),
        financial_class: z.string().nullish(),
        is_active: z.boolean(),
        is_clinical_trial: z.boolean(),
        is_international_patient: z.boolean(),
        is_observation: z.boolean(),
        is_readmission: z.boolean(),
        isolation_status: z.string().nullish(),
        length_of_stay_days: z.number().nullish(),
        patient_home_country: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_mrn: z.string().nullish(),
        patient_name: z.string().nullish(),
        pressure_injury_risk: z.string().nullish(),
        readmission_within_days: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
        referring_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        scheduled_start_datetime: z.iso.datetime().nullish(),
        service_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        translator_language: z.string().nullish(),
        translator_required: z.boolean(),
        visit_reason: z.string().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponseMedicationResponse = z.object({
    data: z.array(z.object({
        administration_instructions: z.string().nullish(),
        allergy_checked: z.boolean(),
        allow_substitution: z.boolean(),
        continue_at_discharge: z.boolean().nullish(),
        dea_schedule: z.string().nullish(),
        dose: z.string(),
        dose_range_checked: z.boolean(),
        dose_unit: z.string().nullish(),
        double_checked: z.boolean(),
        duplicate_therapy_checked: z.boolean(),
        duration: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
        duration_unit: z.string().nullish(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        frequency_code: z.string(),
        frequency_description: z.string().nullish(),
        generic_name: z.string().nullish(),
        indication: z.string().nullish(),
        interaction_checked: z.boolean(),
        is_active: z.boolean(),
        is_controlled: z.boolean(),
        is_high_alert: z.boolean(),
        is_home_medication: z.boolean(),
        is_prn: z.boolean(),
        medication_catalog_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        medication_name: z.string(),
        medication_order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        ndc_code: z.string().nullish(),
        off_label_use: z.boolean(),
        order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        order_number: z.string().nullish(),
        order_status: z.string(),
        ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        ordering_provider_name: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_instructions: z.string().nullish(),
        patient_mrn: z.string().nullish(),
        patient_name: z.string().nullish(),
        pharmacist_verification_required: z.boolean(),
        pharmacist_verified: z.boolean(),
        pharmacy_notes: z.string().nullish(),
        priority: z.string(),
        prn_indication: z.string().nullish(),
        quantity_dispensed: z.number().nullish(),
        refills_authorized: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
        requires_double_check: z.boolean(),
        route: z.string(),
        screened_allergy: z.boolean(),
        screened_dose_range: z.boolean(),
        screened_duplicate_therapy: z.boolean(),
        screened_interaction: z.boolean(),
        substitution_reason: z.string().nullish(),
        total_doses: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
        verified_by_pharmacist_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        verified_datetime: z.iso.datetime().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponseOrderResponse = z.object({
    data: z.array(z.object({
        authorization_number: z.string().nullish(),
        authorization_status: z.string().nullish(),
        body_site: z.string().nullish(),
        clinical_indication: z.string().nullish(),
        completed_datetime: z.iso.datetime().nullish(),
        diagnosis_code: z.string().nullish(),
        discontinuation_reason: z.string().nullish(),
        discontinued_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        discontinued_datetime: z.iso.datetime().nullish(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        external_order_id: z.string().nullish(),
        external_ordering_provider_name: z.string().nullish(),
        has_results: z.boolean(),
        hl7_message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        instructions: z.string().nullish(),
        is_active: z.boolean(),
        laterality: z.string().nullish(),
        order_catalog_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        order_description: z.string().nullish(),
        order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        order_name: z.string(),
        order_number: z.string(),
        order_status: z.string(),
        order_type: z.string(),
        ordered_datetime: z.iso.datetime(),
        ordering_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        ordering_provider_name: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_instructions: z.string().nullish(),
        patient_mrn: z.string().nullish(),
        patient_name: z.string().nullish(),
        performing_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        performing_location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        performing_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        priority: z.string(),
        scheduled_datetime: z.iso.datetime().nullish(),
        source_system: z.string().nullish(),
        special_instructions: z.string().nullish(),
        start_datetime: z.iso.datetime().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponsePatientResponse = z.object({
    data: z.array(z.object({
        age: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
        alternative_name: z.string().nullish(),
        country: z.string(),
        date_of_birth: z.iso.date(),
        first_name: z.string().nullish(),
        full_name: z.string(),
        gender_legal: z.string(),
        is_active: z.boolean(),
        is_restricted: z.boolean(),
        is_vip: z.boolean(),
        last_name: z.string().nullish(),
        mrn: z.string(),
        national_id_number: z.string().nullish(),
        national_id_type: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        primary_phone: z.string().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponsePortalAppointmentResponse = z.object({
    data: z.array(z.object({
        appointment_datetime: z.iso.datetime(),
        appointment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        appointment_type: z.string(),
        can_cancel: z.boolean(),
        can_reschedule: z.boolean(),
        department_name: z.string().nullish(),
        duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
        facility_name: z.string().nullish(),
        facility_time_zone: z.string().nullish(),
        instructions: z.string().nullish(),
        provider_name: z.string().nullish(),
        reason: z.string().nullish(),
        status: z.string()
    })),
    pagination: zPagination
});

export const zPaginatedResponsePortalFormResponse = z.object({
    data: z.array(z.object({
        description: z.string().nullish(),
        due_date: z.iso.date().nullish(),
        fields: z.unknown().optional(),
        form_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        form_name: z.string(),
        form_type: z.string(),
        status: z.string(),
        submitted_date: z.iso.datetime().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponsePortalMessageResponse = z.object({
    data: z.array(z.object({
        body: z.string(),
        category: z.string(),
        created_at: z.iso.datetime(),
        has_attachments: z.boolean(),
        is_read: z.boolean(),
        message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        priority: z.string(),
        read_at: z.iso.datetime().nullish(),
        recipient_name: z.string().nullish(),
        recipient_type: z.string(),
        sender_name: z.string(),
        sender_type: z.string(),
        subject: z.string(),
        thread_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponsePortalResultResponse = z.object({
    data: z.array(z.object({
        facility_time_zone: z.string().nullish(),
        is_abnormal: z.boolean(),
        order_name: z.string().nullish(),
        provider_comments: z.string().nullish(),
        provider_name: z.string().nullish(),
        reference_range: z.string().nullish(),
        result_date: z.iso.datetime(),
        result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        result_name: z.string(),
        result_status: z.string(),
        result_unit: z.string().nullish(),
        result_value: z.string().nullish()
    })),
    pagination: zPagination
});

export const zPaginatedResponseQualityMeasureResultResponse = z.object({
    data: z.array(z.object({
        calculated_at: z.iso.datetime(),
        calculated_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        calculation_source: z.string(),
        data_completeness: z.number().nullish(),
        denominator_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        exclusion_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        measure_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        notes: z.string().nullish(),
        numerator_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        performance_rate: z.number().nullish(),
        reporting_period_end: z.string(),
        reporting_period_start: z.string(),
        result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
    })),
    pagination: zPagination
});

export const zPaginatedResponseWaitlistResponse = z.object({
    data: z.array(z.object({
        added_date: z.iso.datetime(),
        mrn: z.string().nullish(),
        notes: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_name: z.string().nullish(),
        preferred_date_end: z.iso.date().nullish(),
        preferred_date_start: z.iso.date().nullish(),
        provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        provider_name: z.string().nullish(),
        reason_for_visit: z.string().nullish(),
        urgency_level: z.string().nullish(),
        waitlist_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        waitlist_status: z.string().nullish()
    })),
    pagination: zPagination
});

/**
 * One launch-URL parameter binding: `param` names the query parameter the
 * external app expects, `source` names the VynaEMR context path whose value
 * fills it (`patient.mrn`, `encounter.number`, ...). The stored JSON is an
 * array of these — `launch_app` reads it with `as_array()` — so the response
 * schema is a Vec of this shape, not a free-form object.
 */
export const zParameterMappingSchema = z.object({
    param: z.string(),
    source: z.string()
});

/**
 * A pathology report's named sections.
 */
export const zPathologySectionsResponse = z.object({
    gross_description: z.string().nullish(),
    microscopic_description: z.string().nullish(),
    specimen_type: z.string().nullish()
});

/**
 * Full patient detail response — returned by GET /patients/{id}.
 * Contains every demographic column from the Patient table.
 */
export const zPatientDetailResponse = z.object({
    address_line1: z.string().nullish(),
    address_line2: z.string().nullish(),
    address_line3: z.string().nullish(),
    age: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    alternative_name: z.string().nullish(),
    birth_time: z.string().nullish(),
    city: z.string().nullish(),
    confidentiality_level: z.string().nullish(),
    country: z.string(),
    created_at: z.iso.datetime(),
    date_of_birth: z.iso.date(),
    deceased_cause: z.string().nullish(),
    deceased_date: z.iso.datetime().nullish(),
    district: z.string().nullish(),
    education_level: z.string().nullish(),
    email: z.string().nullish(),
    employer_name: z.string().nullish(),
    employer_phone: z.string().nullish(),
    ethnicity: z.array(zCodedDemographic).optional(),
    first_name: z.string().nullish(),
    full_name: z.string(),
    gender_identity: z.string().nullish(),
    gender_legal: z.string(),
    home_country: z.string().nullish(),
    interpreter_required: z.boolean(),
    is_active: z.boolean(),
    is_deceased: z.boolean(),
    is_medical_tourist: z.boolean(),
    is_restricted: z.boolean(),
    is_vip: z.boolean(),
    last_name: z.string().nullish(),
    marital_status: z.string().nullish(),
    middle_name: z.string().nullish(),
    mobile_phone: z.string().nullish(),
    modified_at: z.iso.datetime().nullish(),
    mrn: z.string(),
    name_suffix: z.string().nullish(),
    national_id_number: z.string().nullish(),
    national_id_type: z.string().nullish(),
    nationality: z.string().nullish(),
    occupation: z.string().nullish(),
    organ_donor_status: z.string().nullish(),
    passport_country: z.string().nullish(),
    passport_expiry_date: z.iso.date().nullish(),
    passport_number: z.string().nullish(),
    passport_on_file: z.boolean().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    photo_url: z.string().nullish(),
    postal_code: z.string().nullish(),
    preferred_communication_language: z.string().nullish(),
    preferred_contact_method: z.string().nullish(),
    preferred_name: z.string().nullish(),
    primary_language: z.string(),
    primary_phone: z.string().nullish(),
    race: z.array(zCodedDemographic).optional(),
    religion: z.string().nullish(),
    secondary_language: z.string().nullish(),
    secondary_phone: z.string().nullish(),
    sex_at_birth: z.string().nullish(),
    sexual_orientation: z.string().nullish(),
    state_province: z.string().nullish(),
    visa_expiry_date: z.iso.date().nullish(),
    visa_status: z.string().nullish(),
    work_phone: z.string().nullish()
});

export const zPatientMatchRequest = z.object({
    parameter: z.array(zMatchParameter),
    resourceType: z.string()
});

export const zPatientResponse = z.object({
    age: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    alternative_name: z.string().nullish(),
    country: z.string(),
    date_of_birth: z.iso.date(),
    first_name: z.string().nullish(),
    full_name: z.string(),
    gender_legal: z.string(),
    is_active: z.boolean(),
    is_restricted: z.boolean(),
    is_vip: z.boolean(),
    last_name: z.string().nullish(),
    mrn: z.string(),
    national_id_number: z.string().nullish(),
    national_id_type: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    primary_phone: z.string().nullish()
});

/**
 * One my-patients panel row: the patient plus the active encounter that
 * puts them on the caller's panel and the relationships justifying it.
 */
export const zMyPatientResponse = z.object({
    admitted_at: z.iso.datetime().nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_class: z.string(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    encounter_type: z.string().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient: zPatientResponse,
    relationship_kinds: z.array(z.string())
});

export const zPaginatedResponseMyPatientResponse = z.object({
    data: z.array(z.object({
        admitted_at: z.iso.datetime().nullish(),
        department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        encounter_class: z.string(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        encounter_type: z.string().nullish(),
        facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient: zPatientResponse,
        relationship_kinds: z.array(z.string())
    })),
    pagination: zPagination
});

/**
 * The `POST /patients` 201 body: the created record plus any non-blocking
 * duplicate findings.
 *
 * Returned on EVERY create — `duplicate_warnings` is `[]` when the create is
 * clean. One documented shape (never flat-or-wrapped) so the OpenAPI spec and
 * the FE Zod schema cannot drift from the runtime body. Mirrors
 * `medications::MedicationWithCdsResponse`; the warning is a fact about the
 * act of registering, not a column on the persisted row, so it rides beside
 * the record rather than being folded into it — `get`/`list`/`update` keep
 * returning the flat `PatientResponse`.
 */
export const zPatientWithDuplicatesResponse = z.object({
    duplicate_warnings: z.array(zDuplicateWarning),
    patient: zPatientResponse
});

/**
 * Canonical payment-method taxonomy (R-6.5 Phase 5a). Wire values are
 * snake_case and MUST match the `chk_payment_method` CHECK constraint on
 * `Payment` (`0100_billing.sql`). `rename_all = "snake_case"` is enum-VALUE
 * casing (backend-native), NOT the CLAUDE.md Rule #2 prohibited field-case
 * camelCase bypass.
 */
export const zPaymentMethod = z.enum([
    'cash',
    'check',
    'credit_card',
    'debit_card',
    'bank_transfer',
    'digital_wallet',
    'insurance'
]);

export const zPaginatedResponsePaymentResponse = z.object({
    data: z.array(z.object({
        amount: z.number(),
        claim_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        claim_number: z.string().nullish(),
        created_at: z.iso.datetime(),
        currency: z.string(),
        notes: z.string().nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_name: z.string().nullish(),
        payment_date: z.iso.datetime(),
        payment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        payment_method: zPaymentMethod,
        payment_status: z.string(),
        payment_type: z.string(),
        posted_by: z.string().nullish(),
        reference_number: z.string().nullish()
    })),
    pagination: zPagination
});

export const zPaymentResponse = z.object({
    amount: z.number(),
    claim_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    claim_number: z.string().nullish(),
    created_at: z.iso.datetime(),
    currency: z.string(),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    payment_date: z.iso.datetime(),
    payment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    payment_method: zPaymentMethod,
    payment_status: z.string(),
    payment_type: z.string(),
    posted_by: z.string().nullish(),
    reference_number: z.string().nullish()
});

export const zPatientAccountResponse = z.object({
    account_status: z.string(),
    currency: z.string(),
    last_charge_date: z.iso.datetime().nullish(),
    last_payment_date: z.iso.datetime().nullish(),
    mrn: z.string().nullish(),
    outstanding_balance: z.number(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    recent_charges: z.array(zChargeResponse),
    recent_payments: z.array(zPaymentResponse),
    total_adjustments: z.number(),
    total_charges: z.number(),
    total_payments: z.number()
});

export const zPermissionResponse = z.object({
    action: z.string().nullish(),
    category_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    description: z.string().nullish(),
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    key: z.string(),
    label: z.string(),
    resource_type: z.string().nullish()
});

/**
 * A pharmacist's verification of a medication order.
 *
 * Pharmacist review IS these four checks — allergy, interaction, duplicate
 * therapy, dose. Before this, the endpoint recorded only that someone had clicked
 * verify, and took the pharmacist's identity from the request body.
 *
 * The verifier is now the authenticated caller; there is no id field to forge.
 */
export const zPharmacistVerifyRequest = z.object({
    allergy_checked: z.boolean(),
    dose_range_checked: z.boolean(),
    duplicate_therapy_checked: z.boolean(),
    interaction_checked: z.boolean(),
    pharmacy_notes: z.string().nullish()
});

export const zPortalAppointmentResponse = z.object({
    appointment_datetime: z.iso.datetime(),
    appointment_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    appointment_type: z.string(),
    can_cancel: z.boolean(),
    can_reschedule: z.boolean(),
    department_name: z.string().nullish(),
    duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    facility_name: z.string().nullish(),
    facility_time_zone: z.string().nullish(),
    instructions: z.string().nullish(),
    provider_name: z.string().nullish(),
    reason: z.string().nullish(),
    status: z.string()
});

export const zPortalFormResponse = z.object({
    description: z.string().nullish(),
    due_date: z.iso.date().nullish(),
    fields: z.unknown().optional(),
    form_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    form_name: z.string(),
    form_type: z.string(),
    status: z.string(),
    submitted_date: z.iso.datetime().nullish()
});

export const zPortalLoginRequest = z.object({
    email: z.string(),
    mfa_code: z.string().nullish(),
    password: z.string()
});

export const zPortalMessageResponse = z.object({
    body: z.string(),
    category: z.string(),
    created_at: z.iso.datetime(),
    has_attachments: z.boolean(),
    is_read: z.boolean(),
    message_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    priority: z.string(),
    read_at: z.iso.datetime().nullish(),
    recipient_name: z.string().nullish(),
    recipient_type: z.string(),
    sender_name: z.string(),
    sender_type: z.string(),
    subject: z.string(),
    thread_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zPortalRegisterRequest = z.object({
    date_of_birth: z.iso.date(),
    email: z.string(),
    full_name: z.string(),
    mrn: z.string().nullish(),
    national_id_number: z.string().nullish(),
    national_id_type: z.string().nullish(),
    password: z.string(),
    preferred_language: z.string().nullish()
});

export const zPortalResultResponse = z.object({
    facility_time_zone: z.string().nullish(),
    is_abnormal: z.boolean(),
    order_name: z.string().nullish(),
    provider_comments: z.string().nullish(),
    provider_name: z.string().nullish(),
    reference_range: z.string().nullish(),
    result_date: z.iso.datetime(),
    result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    result_name: z.string(),
    result_status: z.string(),
    result_unit: z.string().nullish(),
    result_value: z.string().nullish()
});

export const zPortalUserResponse = z.object({
    created_at: z.iso.datetime(),
    date_of_birth: z.iso.date(),
    email: z.string(),
    full_name: z.string(),
    is_linked_to_patient: z.boolean(),
    is_verified: z.boolean(),
    last_login: z.iso.datetime().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    phone: z.string().nullish(),
    portal_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    preferred_language: z.string()
});

export const zPortalLoginResponse = z.object({
    access_token: z.string(),
    expires_in: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    refresh_token: z.string(),
    token_type: z.string(),
    user: zPortalUserResponse
});

export const zProblemSummary = z.object({
    icd_code: z.string().nullish(),
    onset_date: z.iso.date().nullish(),
    problem_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    problem_name: z.string(),
    status: z.string()
});

export const zProjectorLagResponse = z.object({
    lag: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    last_outbox_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    max_relevant_outbox_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    projector_name: z.string(),
    status: z.string()
});

export const zQualityMeasureResponse = z.object({
    category: z.string(),
    cms_id: z.string().nullish(),
    cms_version: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    denominator: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    description: z.string().nullish(),
    direction: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_active: z.boolean(),
    last_calculated: z.iso.datetime(),
    measure_code: z.string(),
    measure_guid: z.string().nullish(),
    measure_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    measure_name: z.string(),
    measure_type: z.string(),
    numerator: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    rate: z.number(),
    reporting_period_end: z.iso.date(),
    reporting_period_start: z.iso.date(),
    target_rate: z.number().nullish(),
    unit: z.string().nullish()
});

export const zQualityMeasureResultResponse = z.object({
    calculated_at: z.iso.datetime(),
    calculated_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    calculation_source: z.string(),
    data_completeness: z.number().nullish(),
    denominator_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    exclusion_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    measure_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    notes: z.string().nullish(),
    numerator_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    performance_rate: z.number().nullish(),
    reporting_period_end: z.string(),
    reporting_period_start: z.string(),
    result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Body for retry / skip / abandon / resend. The reason is required for
 * audit traceability — every state transition driven by an operator
 * must carry an attributable rationale (per Cluster G design §3:
 * "Missing reason → 400" applies to all four actions, including
 * retry, so operators can't undo a failure without justifying it).
 *
 * Serde rejects missing fields with a 400-mapped deser error; the
 * runtime check below additionally rejects whitespace-only / empty
 * strings so an operator can't pass `""` to bypass the requirement.
 */
export const zReasonBody = z.object({
    reason: z.string()
});

/**
 * Body for recording an in-app dispense.
 *
 * `patient_id` / `encounter_id` are derived at the data tier from the order and
 * the recording user is the authenticated caller, so none is accepted here.
 * The provenance fields are likewise absent: a REST client must not be able to
 * claim that some partner message asserted this.
 */
export const zRecordDispenseBody = z.object({
    days_supply: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    destination: z.string().nullish(),
    dispense_type: z.string().nullish(),
    medication_code: z.string().nullish(),
    medication_coding_system: z.string().nullish(),
    medication_name: z.string().nullish(),
    note: z.string().nullish(),
    performer_name: z.string().nullish(),
    quantity: z.string().nullish(),
    quantity_unit: z.string().nullish(),
    receiver_name: z.string().nullish(),
    status: z.string().nullish(),
    substitution_reason: z.string().nullish(),
    was_substituted: z.boolean().optional(),
    when_handed_over: z.string().nullish(),
    when_prepared: z.string().nullish()
});

export const zRecordQualityMeasureResultRequest = z.object({
    calculation_source: z.string().optional(),
    data_completeness: z.number().nullish(),
    denominator_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    exclusion_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    notes: z.string().nullish(),
    numerator_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    reporting_period_end: z.string(),
    reporting_period_start: z.string()
});

export const zRefreshRequest = z.object({
    refresh_token: z.string()
});

export const zRefreshResponse = z.object({
    access_token: z.string(),
    expires_in: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    mfa_setup_required: z.boolean(),
    refresh_token: z.string(),
    token_type: z.string()
});

export const zReportColumn = z.object({
    data_type: z.string(),
    label: z.string(),
    name: z.string()
});

export const zReportParameter = z.object({
    default_value: z.string().nullish(),
    label: z.string(),
    name: z.string(),
    parameter_type: z.string(),
    required: z.boolean()
});

export const zPaginatedResponseReportDefinitionResponse = z.object({
    data: z.array(z.object({
        category: z.string(),
        created_at: z.iso.datetime(),
        description: z.string().nullish(),
        is_active: z.boolean(),
        parameters: z.array(zReportParameter),
        report_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        report_name: z.string(),
        report_type: z.string()
    })),
    pagination: zPagination
});

export const zReportDefinitionResponse = z.object({
    category: z.string(),
    created_at: z.iso.datetime(),
    description: z.string().nullish(),
    is_active: z.boolean(),
    parameters: z.array(zReportParameter),
    report_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    report_name: z.string(),
    report_type: z.string()
});

export const zReportResultResponse = z.object({
    columns: z.array(zReportColumn),
    data: z.array(z.unknown()),
    execution_id: z.string(),
    execution_time_ms: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    generated_at: z.iso.datetime(),
    output_format: z.string(),
    report_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    report_name: z.string(),
    row_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    status: z.string()
});

/**
 * POST /portal/resend-verification — re-issue a verification email (public endpoint).
 *
 * Recovery for the register commit→outbox gap (S4-007: the row committed
 * but the email never enqueued) and for expired/lost links. Anti-oracle:
 * unknown emails, already-verified accounts and success all answer the
 * same 200 — only an infra failure 500s, which reveals nothing about
 * any account.
 */
export const zResendVerificationRequest = z.object({
    email: z.string()
});

/**
 * Resolve a pharmacy-versus-prescriber clarification.
 *
 * `upheld` rather than `rejected`: the outcome that matters is what happened
 * to the ORDER, not how the pharmacy's message was received.
 */
export const zResolveClarificationRequest = z.object({
    note: z.string().nullish(),
    resolution: z.string()
});

export const zResultSummary = z.object({
    facility_time_zone: z.string().nullish(),
    is_abnormal: z.boolean(),
    result_date: z.iso.datetime(),
    result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    result_name: z.string(),
    result_value: z.string().nullish(),
    status: z.string()
});

export const zPatientSummaryResponse = z.object({
    active_medications: z.array(zMedicationSummary),
    active_problems: z.array(zProblemSummary),
    age: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    allergies: z.array(zAllergySummary),
    blood_type: z.string().nullish(),
    date_of_birth: z.iso.date(),
    emergency_contact: zEmergencyContactSummary.nullish(),
    full_name: z.string(),
    gender: z.string(),
    immunizations: z.array(zImmunizationSummary),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    recent_results: z.array(zResultSummary),
    upcoming_appointments: z.array(zAppointmentSummary)
});

export const zReviewCampaignResponse = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    certified_items: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    closed_at: z.iso.datetime().nullish(),
    created_at: z.iso.datetime(),
    created_by_name: z.string().nullish(),
    created_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    due_date: z.iso.date().nullish(),
    name: z.string(),
    pending_items: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    revoked_items: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    status: z.string(),
    total_items: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zReviewEntryBody = z.object({
    decision: z.string()
});

export const zReviewItemResponse = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    decided_at: z.iso.datetime().nullish(),
    decided_by_name: z.string().nullish(),
    decided_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    decision: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    item_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    live: z.boolean(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    snap_effective_date: z.iso.date().nullish(),
    snap_expiration_date: z.iso.date().nullish(),
    snap_facility_name: z.string().nullish(),
    snap_granted_by: z.string().nullish(),
    snap_role_code: z.string(),
    snap_role_name: z.string(),
    snap_user_name: z.string(),
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zReviewCampaignDetailResponse = z.object({
    campaign: zReviewCampaignResponse,
    items: z.array(zReviewItemResponse)
});

/**
 * One role granted at one facility scope (F5).
 *
 * A pair rather than a role list beside a single facility: the flat shape
 * cannot express "nurse at site A, auditor at site B" without also granting
 * auditor at A. One role held at three sites is three entries.
 *
 * `facility_id: None` is a health-system-wide grant, and it widens PATIENT
 * access rather than merely reporting reach — the JWT's `facility_ids` claim
 * is derived entirely from these rows (!405), which is why the form requires
 * an explicit acknowledgement for it.
 */
export const zRoleAssignmentInput = z.object({
    effective_date: z.iso.date().nullish(),
    expiration_date: z.iso.date().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zCreateUserPayload = z.object({
    email: z.string(),
    full_name: z.string(),
    is_active: z.boolean().optional(),
    password: z.string(),
    role_assignments: z.array(zRoleAssignmentInput).optional(),
    username: z.string()
});

export const zRoleCategoryResponse = z.object({
    audit_level: z.string(),
    category_code: z.string(),
    category_description: z.string().nullish(),
    category_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    category_name: z.string(),
    display_order: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    is_active: z.boolean(),
    max_failed_logins: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    max_session_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    mfa_required: z.boolean(),
    password_expiry_days: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    role_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zRoleDetailResponse = z.object({
    category_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    category_name: z.string().nullish(),
    effective_permission_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_active: z.boolean(),
    is_system_role: z.boolean(),
    own_permission_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    parent_role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    parent_role_name: z.string().nullish(),
    role_code: z.string(),
    role_description: z.string().nullish(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_name: z.string(),
    user_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zAccessMatrixResponse = z.object({
    denied: z.array(zMatrixDenied),
    granted: z.array(zMatrixGrant),
    permissions: z.array(zMatrixPermissionInfo),
    roles: z.array(zRoleDetailResponse)
});

export const zRotateSecretResponse = z.object({
    app_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    client_id: z.string(),
    client_secret: z.string()
});

export const zRunReportRequest = z.object({
    output_format: z.string().nullish(),
    parameters: z.unknown(),
    report_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * ACS form, as the IdP POSTs it (`SAMLResponse` + `RelayState`).
 */
export const zSamlAcsForm = z.object({
    RelayState: z.string().nullish(),
    SAMLResponse: z.string().nullish()
});

/**
 * Artifact exchange body: what the SPA callback page POSTs.
 */
export const zSamlExchangeRequest = z.object({
    artifact: z.string()
});

export const zScheduleTemplateResponse = z.object({
    appointment_duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    created_at: z.iso.datetime(),
    day_of_week: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    effective_end_date: z.iso.date().nullish(),
    effective_start_date: z.iso.date(),
    end_time: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_active: z.boolean(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    start_time: z.string(),
    template_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    template_name: z.string()
});

export const zScimTokenResponse = z.object({
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_name: z.string(),
    is_active: z.boolean(),
    label: z.string(),
    token_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    token_prefix: z.string()
});

/**
 * Mint response: the row plus the ONE rendering of the plaintext
 * secret. The server keeps the hash; Entra's tenant URL + this secret
 * are the provisioning credential pair. Nested so the token row stays
 * a reusable `$ref` in the generated client.
 */
export const zMintedScimTokenResponse = z.object({
    secret: z.string(),
    token: zScimTokenResponse
});

/**
 * Request to send an HL7 message via HTTP
 */
export const zSendHohMessageRequest = z.object({
    correlation_id: z.string().nullish(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    message_raw: z.string()
});

/**
 * Response for HoH send operation
 */
export const zSendHohMessageResponse = z.object({
    ack_code: z.string().nullish(),
    ack_message: z.string().nullish(),
    error: z.string().nullish(),
    success: z.boolean()
});

/**
 * Request to send an outbound HL7 message
 */
export const zSendMessageRequest = z.object({
    correlation_id: z.string().nullish(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    message_raw: z.string()
});

/**
 * Response for send operation
 */
export const zSendMessageResponse = z.object({
    ack_code: z.string().nullish(),
    ack_message: z.string().nullish(),
    error: z.string().nullish(),
    success: z.boolean()
});

/**
 * One antibiotic's result for one organism.
 */
export const zSensitivityResponse = z.object({
    antibiotic_code: z.string(),
    antibiotic_name: z.string(),
    interpretation: z.string(),
    mic_unit: z.string().nullish(),
    mic_value: z.number().nullish()
});

/**
 * One organism in a culture, with the susceptibilities reported against it.
 *
 * The grouping is not cosmetic. HL7 links a susceptibility to its organism by
 * OBX-4 and nothing else, so a two-organism culture reports the same
 * antibiotic twice with different verdicts. Flattening the panel would put
 * both in front of a prescriber with nothing saying which was which.
 */
export const zMicrobiologyOrganismResponse = z.object({
    culture_type: z.string().nullish(),
    gram_stain_result: z.string().nullish(),
    organism_code: z.string().nullish(),
    organism_name: z.string().nullish(),
    sensitivities: z.array(zSensitivityResponse),
    specimen_source: z.string().nullish()
});

export const zPaginatedResponseResultResponse = z.object({
    data: z.array(z.object({
        addendum_text: z.string().nullish(),
        amended_result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        amendment_reason: z.string().nullish(),
        cardiology: zCardiologyMeasurementsResponse.nullish(),
        clinical_significance: z.string().nullish(),
        comparison_result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        components: z.array(zLabComponentResponse),
        critical_acknowledged: z.boolean(),
        critical_acknowledged_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        critical_acknowledged_datetime: z.iso.datetime().nullish(),
        critical_notification_sent: z.boolean(),
        encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        imaging: zImagingStudyResponse.nullish(),
        impression: z.string().nullish(),
        interpreted_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        is_active: z.boolean(),
        is_corrected: z.boolean(),
        is_critical: z.boolean(),
        is_delta_check_abnormal: z.boolean(),
        is_panic_value: z.boolean(),
        microbiology: z.array(zMicrobiologyOrganismResponse),
        order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        order_number: z.string().nullish(),
        pathologist_notes: z.string().nullish(),
        pathology: zPathologySectionsResponse.nullish(),
        patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        patient_mrn: z.string().nullish(),
        patient_name: z.string().nullish(),
        performing_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        performing_provider_name: z.string().nullish(),
        radiologist_notes: z.string().nullish(),
        recommendations: z.string().nullish(),
        report_html: z.string().nullish(),
        report_pdf_url: z.string().nullish(),
        report_text: z.string().nullish(),
        result_available_datetime: z.iso.datetime().nullish(),
        result_code: z.string().nullish(),
        result_code_system: z.string().nullish(),
        result_datetime: z.iso.datetime(),
        result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
        result_name: z.string().nullish(),
        result_number: z.string(),
        result_status: z.string(),
        result_type: z.string(),
        specimen_collection_datetime: z.iso.datetime().nullish(),
        technician_notes: z.string().nullish(),
        verified_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
        verified_datetime: z.iso.datetime().nullish()
    })),
    pagination: zPagination
});

export const zResultResponse = z.object({
    addendum_text: z.string().nullish(),
    amended_result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    amendment_reason: z.string().nullish(),
    cardiology: zCardiologyMeasurementsResponse.nullish(),
    clinical_significance: z.string().nullish(),
    comparison_result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    components: z.array(zLabComponentResponse),
    critical_acknowledged: z.boolean(),
    critical_acknowledged_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    critical_acknowledged_datetime: z.iso.datetime().nullish(),
    critical_notification_sent: z.boolean(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    imaging: zImagingStudyResponse.nullish(),
    impression: z.string().nullish(),
    interpreted_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_active: z.boolean(),
    is_corrected: z.boolean(),
    is_critical: z.boolean(),
    is_delta_check_abnormal: z.boolean(),
    is_panic_value: z.boolean(),
    microbiology: z.array(zMicrobiologyOrganismResponse),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    order_number: z.string().nullish(),
    pathologist_notes: z.string().nullish(),
    pathology: zPathologySectionsResponse.nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_mrn: z.string().nullish(),
    patient_name: z.string().nullish(),
    performing_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    performing_provider_name: z.string().nullish(),
    radiologist_notes: z.string().nullish(),
    recommendations: z.string().nullish(),
    report_html: z.string().nullish(),
    report_pdf_url: z.string().nullish(),
    report_text: z.string().nullish(),
    result_available_datetime: z.iso.datetime().nullish(),
    result_code: z.string().nullish(),
    result_code_system: z.string().nullish(),
    result_datetime: z.iso.datetime(),
    result_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    result_name: z.string().nullish(),
    result_number: z.string(),
    result_status: z.string(),
    result_type: z.string(),
    specimen_collection_datetime: z.iso.datetime().nullish(),
    technician_notes: z.string().nullish(),
    verified_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    verified_datetime: z.iso.datetime().nullish()
});

export const zBatchAcknowledgeCriticalResponse = z.object({
    acknowledged: z.array(zResultResponse)
});

/**
 * Server runtime status
 */
export const zServerStatus = z.object({
    active_connections: z.int().gte(0),
    bind_address: z.string(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    interface_name: z.string(),
    started_at: z.iso.datetime(),
    total_messages_received: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zServerListResponse = z.object({
    count: z.int().gte(0),
    servers: z.array(zServerStatus)
});

export const zSetCategoryPermissionsRequest = z.object({
    permission_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))
});

export const zSetDeniedPermissionsRequest = z.object({
    denied: z.array(zDeniedPermissionEntry)
});

export const zSetRolePermissionsRequest = z.object({
    permission_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }))
});

export const zSetUserPasswordPayload = z.object({
    password: z.string()
});

export const zSetUserStatusPayload = z.object({
    is_active: z.boolean()
});

/**
 * First-run setup claim request. The installer picks the admin username
 * (the UI pre-fills `admin`); the password must satisfy the shared staff
 * strength policy. Email is derived gateway-side.
 */
export const zSetupClaimPayload = z.object({
    password: z.string(),
    username: z.string()
});

/**
 * The claimed install-time admin (minimal: the page navigates to login).
 */
export const zSetupClaimResponse = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    username: z.string()
});

/**
 * Setup gate status for the login bounce.
 */
export const zSetupStatusResponse = z.object({
    armed: z.boolean(),
    user_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zSignNoteRequest = z.object({
    signed_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zSmartAppRow = z.object({
    app_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    client_id: z.string(),
    created_at: z.iso.datetime().nullish(),
    is_active: z.boolean(),
    last_access: z.iso.datetime().nullish(),
    launch_url: z.string().nullish(),
    logo_url: z.string().nullish(),
    modified_at: z.iso.datetime().nullish(),
    name: z.string(),
    redirect_uris: z.array(z.string()),
    scope: z.string(),
    scopes: z.array(z.string()),
    status: z.string()
});

export const zCreateSmartAppResponse = zSmartAppRow.and(z.object({
    client_secret: z.string()
}));

export const zSmartConfiguration = z.object({
    authorizationEndpoint: z.string(),
    capabilities: z.array(z.string()),
    codeChallengeMethodsSupported: z.array(z.string()),
    grantTypesSupported: z.array(z.string()),
    issuer: z.string(),
    responseTypesSupported: z.array(z.string()),
    scopesSupported: z.array(z.string()),
    tokenEndpoint: z.string()
});

export const zSmartPhraseResponse = z.object({
    category: z.string().nullish(),
    created_at: z.string(),
    created_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    expansion_text: z.string(),
    is_active: z.boolean(),
    phrase_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    phrase_key: z.string()
});

/**
 * Full directory row for the admin UI. The sealed bind password never
 * serializes — `has_bind_password` (and `has_ca` for the bundle) tells
 * the form what is set.
 */
export const zSsoDirectoryResponse = z.object({
    base_dn: z.string(),
    bind_dn: z.string(),
    directory_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    enabled: z.boolean(),
    group_attribute: z.string(),
    has_bind_password: z.boolean(),
    has_ca: z.boolean(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_name: z.string(),
    host: z.string(),
    name: z.string(),
    name_attribute: z.string(),
    port: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    tls_mode: z.string(),
    tls_verify: z.boolean(),
    user_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    user_filter: z.string()
});

export const zSsoDomainResponse = z.object({
    domain: z.string(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_name: z.string()
});

export const zSsoGroupMapResponse = z.object({
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    facility_name: z.string(),
    group_value: z.string(),
    map_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    provider_name: z.string(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_name: z.string()
});

export const zSsoLdapMapResponse = z.object({
    directory_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    directory_name: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    facility_name: z.string(),
    ldap_group: z.string(),
    map_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_name: z.string()
});

/**
 * One enabled provider, as the login page lists it. Names the provider —
 * never secrets, URLs, or user data (the VynaECG `providers` shape).
 * S5: `provider` (`oidc`|`saml`) routes the login page to the right leg.
 * Deliberately no `health_system_id`: the picker never uses it, and
 * this list is public pre-auth — every field here is enumerable.
 */
export const zSsoProviderInfo = z.object({
    name: z.string(),
    provider: z.string(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Full provider row for the admin UI. The sealed client secret never
 * serializes — `has_secret` tells the form whether one is set.
 */
export const zSsoProviderResponse = z.object({
    client_id: z.string(),
    enabled: z.boolean(),
    group_claim: z.string(),
    has_secret: z.boolean(),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_name: z.string(),
    idp_metadata: z.string(),
    issuer: z.string(),
    name: z.string(),
    provider: z.string(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    user_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Provider connectivity answer: ALWAYS 200 — `ok` carries the verdict
 * (the LDAP test shape), so an unreachable issuer is data, not an error.
 */
export const zSsoTestResult = z.object({
    detail: z.string(),
    ok: z.boolean()
});

/**
 * Request to start an HoH server
 */
export const zStartHohServerRequest = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Request to start an MLLP server
 */
export const zStartServerRequest = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zStatementHistoryItem = z.object({
    amount: z.number(),
    delivery_method: z.string(),
    mrn: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    statement_date: z.iso.date(),
    statement_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    status: z.string()
});

export const zStatementHistoryResponse = z.object({
    data: z.array(zStatementHistoryItem)
});

export const zStatementPreviewLineItem = z.object({
    balance: z.number(),
    charges: z.number(),
    date: z.iso.datetime(),
    description: z.string(),
    payments: z.number()
});

export const zStatementPreviewResponse = z.object({
    closing_balance: z.number(),
    line_items: z.array(zStatementPreviewLineItem),
    mrn: z.string().nullish(),
    opening_balance: z.number(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    period_from: z.iso.date(),
    period_to: z.iso.date(),
    statement_date: z.iso.datetime(),
    total_charges: z.number(),
    total_payments: z.number()
});

export const zStatementResponse = z.object({
    balance_due: z.number(),
    currency: z.string(),
    date_from: z.iso.date(),
    date_to: z.iso.date(),
    line_items: z.array(zChargeResponse),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    statement_date: z.iso.datetime(),
    statement_id: z.string(),
    total_charges: z.number(),
    total_payments: z.number()
});

export const zSubmitFormRequest = z.object({
    form_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    responses: z.unknown(),
    signature: z.string().nullish()
});

/**
 * Hold an order. The reason is required — see [`suspend_medication`].
 */
export const zSuspendMedicationRequest = z.object({
    suspension_reason: z.string()
});

/**
 * Change the login department of the current session — Epic's Change Context.
 */
export const zSwitchDepartmentRequest = z.object({
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * The re-minted session. Carries `active_department_id` back so the client
 * renders the department it is now working in without decoding the token.
 */
export const zSwitchDepartmentResponse = z.object({
    access_token: z.string(),
    active_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    expires_in: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    refresh_token: z.string(),
    token_type: z.string()
});

export const zThirdPartyAppResponse = z.object({
    allowed_facility_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })).nullish(),
    app_category: z.string(),
    app_code: z.string(),
    app_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    app_name: z.string(),
    base_url: z.string(),
    created_at: z.string(),
    display_in_chart: z.boolean(),
    display_in_sidebar: z.boolean(),
    display_order: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    encryption_algorithm: z.string().nullish(),
    encryption_enabled: z.boolean(),
    icon_name: z.string().nullish(),
    is_active: z.boolean(),
    launch_method: z.string(),
    modified_at: z.string().nullish(),
    parameter_mappings: z.array(zParameterMappingSchema),
    required_permission: z.string().nullish(),
    signature_enabled: z.boolean()
});

export const zTimeseriesBucket = z.object({
    avg_ack_latency_ms: z.number().nullish(),
    bucket_start: z.iso.datetime(),
    inbound_errored: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    inbound_received: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    outbound_completed: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    outbound_failed: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    outbound_queued: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    p95_ack_latency_ms: z.number().nullish()
});

export const zTimeseriesResponse = z.object({
    bucket_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    buckets: z.array(zTimeseriesBucket),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    window_hours: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

/**
 * Token pair response
 */
export const zTokenPair = z.object({
    access_token: z.string(),
    expires_in: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    mfa_setup_required: z.boolean(),
    refresh_token: z.string(),
    token_type: z.string()
});

export const zTransferRequest = z.object({
    notes: z.string().nullish(),
    to_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    to_location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    to_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    transfer_reason: z.string().nullish()
});

export const zTransferResponse = z.object({
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    end_datetime: z.iso.datetime().nullish(),
    event_type: z.string(),
    location_history_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    notes: z.string().nullish(),
    reason: z.string().nullish(),
    recorded_date: z.iso.datetime(),
    start_datetime: z.iso.datetime()
});

export const zUpdateAppRequest = z.object({
    allowed_facility_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })).nullish(),
    app_category: z.string().nullish(),
    app_name: z.string().nullish(),
    base_url: z.string().nullish(),
    display_in_chart: z.boolean().nullish(),
    display_in_sidebar: z.boolean().nullish(),
    display_order: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    encryption_algorithm: z.string().nullish(),
    encryption_enabled: z.boolean().nullish(),
    encryption_key: z.string().nullish(),
    icon_name: z.string().nullish(),
    is_active: z.boolean().nullish(),
    launch_method: z.string().nullish(),
    parameter_mappings: z.unknown().optional(),
    required_permission: z.string().nullish(),
    signature_enabled: z.boolean().nullish(),
    signature_key: z.string().nullish()
});

export const zUpdateAppointmentRequest = z.object({
    appointment_datetime: z.iso.datetime().nullish(),
    appointment_type: z.string().nullish(),
    duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    notes: z.string().nullish(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    reason: z.string().nullish(),
    room_number: z.string().nullish()
});

export const zUpdateCategoryRequest = z.object({
    audit_level: z.string().nullish(),
    category_description: z.string().nullish(),
    category_name: z.string().nullish(),
    display_order: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    is_active: z.boolean().nullish(),
    max_failed_logins: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    max_session_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    mfa_required: z.boolean().nullish(),
    password_expiry_days: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

export const zUpdateDashboardRequest = z.object({
    dashboard_name: z.string().nullish(),
    description: z.string().nullish(),
    is_default: z.boolean().nullish(),
    is_shared: z.boolean().nullish(),
    layout: z.string().nullish(),
    widgets: z.array(zDashboardWidget).nullish()
});

export const zUpdateDenialStatusRequest = z.object({
    appeal_reason: z.string().nullish(),
    status: z.string()
});

export const zUpdateDenialStatusResponse = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    status: z.string()
});

export const zUpdateEncounterRequest = z.object({
    acuity_level: z.string().nullish(),
    attending_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    chief_complaint: z.string().nullish(),
    current_location_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_status: z.string().nullish(),
    fall_risk_level: z.string().nullish(),
    isolation_status: z.string().nullish(),
    pressure_injury_risk: z.string().nullish(),
    visit_reason: z.string().nullish()
});

export const zUpdateNoteRequest = z.object({
    assessment: z.string().nullish(),
    chief_complaint: z.string().nullish(),
    content: z.string().nullish(),
    history_present_illness: z.string().nullish(),
    plan: z.string().nullish(),
    title: z.string().nullish()
});

export const zUpdateOrderRequest = z.object({
    clinical_indication: z.string().nullish(),
    diagnosis_code: z.string().nullish(),
    instructions: z.string().nullish(),
    order_description: z.string().nullish(),
    order_status: z.string().nullish(),
    patient_instructions: z.string().nullish(),
    priority: z.string().nullish(),
    scheduled_datetime: z.iso.datetime().nullish(),
    special_instructions: z.string().nullish()
});

export const zUpdatePatientRequest = z.object({
    address_line1: z.string().nullish(),
    address_line2: z.string().nullish(),
    address_line3: z.string().nullish(),
    alternative_name: z.string().nullish(),
    birth_time: z.string().nullish(),
    city: z.string().nullish(),
    confidentiality_level: z.string().nullish(),
    country: z.string().nullish(),
    date_of_birth: z.iso.date().nullish(),
    district: z.string().nullish(),
    education_level: z.string().nullish(),
    email: z.string().nullish(),
    employer_name: z.string().nullish(),
    employer_phone: z.string().nullish(),
    ethnicity: z.array(zCodedDemographic).nullish(),
    first_name: z.string().nullish(),
    full_name: z.string().nullish(),
    gender_identity: z.string().nullish(),
    gender_legal: z.string().nullish(),
    home_country: z.string().nullish(),
    interpreter_required: z.boolean().nullish(),
    is_active: z.boolean().nullish(),
    is_medical_tourist: z.boolean().nullish(),
    is_vip: z.boolean().nullish(),
    last_name: z.string().nullish(),
    marital_status: z.string().nullish(),
    middle_name: z.string().nullish(),
    mobile_phone: z.string().nullish(),
    name_suffix: z.string().nullish(),
    national_id_number: z.string().nullish(),
    national_id_type: z.string().nullish(),
    nationality: z.string().nullish(),
    occupation: z.string().nullish(),
    organ_donor_status: z.string().nullish(),
    passport_country: z.string().nullish(),
    passport_expiry_date: z.iso.date().nullish(),
    passport_number: z.string().nullish(),
    passport_on_file: z.boolean().nullish(),
    photo_url: z.string().nullish(),
    postal_code: z.string().nullish(),
    preferred_communication_language: z.string().nullish(),
    preferred_contact_method: z.string().nullish(),
    preferred_name: z.string().nullish(),
    primary_language: z.string().nullish(),
    primary_phone: z.string().nullish(),
    race: z.array(zCodedDemographic).nullish(),
    religion: z.string().nullish(),
    secondary_language: z.string().nullish(),
    secondary_phone: z.string().nullish(),
    sex_at_birth: z.string().nullish(),
    sexual_orientation: z.string().nullish(),
    state_province: z.string().nullish(),
    visa_expiry_date: z.iso.date().nullish(),
    visa_status: z.string().nullish(),
    work_phone: z.string().nullish()
});

export const zUpdatePermissionRequest = z.object({
    action: z.string().nullish(),
    description: z.string().nullish(),
    is_active: z.boolean().nullish(),
    permission_name: z.string().nullish(),
    resource: z.string().nullish()
});

export const zUpdatePortalUserRequest = z.object({
    email: z.string().nullish(),
    full_name: z.string().nullish(),
    preferred_language: z.string().nullish()
});

export const zUpdateProfileRequest = z.object({
    email: z.string().nullish(),
    first_name: z.string().nullish(),
    full_name: z.string().nullish(),
    last_name: z.string().nullish(),
    mobile: z.string().nullish(),
    phone: z.string().nullish(),
    preferred_language: z.string().nullish(),
    timezone: z.string().nullish()
});

export const zUpdateResultRequest = z.object({
    amendment_reason: z.string().nullish(),
    clinical_significance: z.string().nullish(),
    impression: z.string().nullish(),
    interpreted_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_critical: z.boolean().nullish(),
    is_panic_value: z.boolean().nullish(),
    pathologist_notes: z.string().nullish(),
    radiologist_notes: z.string().nullish(),
    recommendations: z.string().nullish(),
    report_html: z.string().nullish(),
    report_pdf_url: z.string().nullish(),
    report_text: z.string().nullish(),
    result_status: z.string().nullish(),
    technician_notes: z.string().nullish(),
    verified_by_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zUpdateRoleRequest = z.object({
    category_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_active: z.boolean().nullish(),
    parent_role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_description: z.string().nullish(),
    role_name: z.string().nullish()
});

export const zUpdateSmartAppRequest = z.object({
    is_active: z.boolean().nullish(),
    launch_url: z.string().nullish(),
    logo_url: z.string().nullish(),
    name: z.string().nullish(),
    redirect_uris: z.array(z.string()).nullish(),
    scopes: z.array(z.string()).nullish(),
    service_principal_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

export const zUpdateSmartPhraseRequest = z.object({
    category: z.string().nullish(),
    expansion_text: z.string().nullish(),
    is_active: z.boolean().nullish(),
    phrase_key: z.string().nullish()
});

/**
 * PUT-with-presence: absent keeps, present sets. `bind_password`: absent
 * keeps, blank clears, value seals-and-replaces. `port` has no
 * clear-to-NULL (absent keeps, present sets).
 */
export const zUpdateSsoDirectoryRequest = z.object({
    base_dn: z.string().nullish(),
    bind_dn: z.string().nullish(),
    bind_password: z.string().nullish(),
    ca_pem: z.string().nullish(),
    enabled: z.boolean().nullish(),
    group_attribute: z.string().nullish(),
    host: z.string().nullish(),
    name: z.string().nullish(),
    name_attribute: z.string().nullish(),
    port: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    tls_mode: z.string().nullish(),
    tls_verify: z.boolean().nullish(),
    user_filter: z.string().nullish()
});

/**
 * PUT-with-presence: absent keeps, present sets. `client_secret`: absent
 * keeps, blank clears, value seals-and-replaces. Kind flips carry rules:
 * to SAML requires fresh `idp_metadata`; to OIDC auto-clears metadata
 * and requires `client_id`.
 */
export const zUpdateSsoProviderRequest = z.object({
    client_id: z.string().nullish(),
    client_secret: z.string().nullish(),
    enabled: z.boolean().nullish(),
    group_claim: z.string().nullish(),
    idp_metadata: z.string().nullish(),
    issuer: z.string().nullish(),
    name: z.string().nullish(),
    provider: z.string().nullish()
});

export const zUpdateTemplateRequest = z.object({
    content: z.string().nullish(),
    is_active: z.boolean().nullish(),
    note_type: z.string().nullish(),
    sections: z.array(z.string()).nullish(),
    specialty: z.string().nullish(),
    template_name: z.string().nullish()
});

export const zUpdateUserGroupRequest = z.object({
    is_active: z.boolean().nullish(),
    name: z.string().nullish()
});

export const zUpdateUserPayload = z.object({
    email: z.string(),
    full_name: z.string(),
    is_active: z.boolean().optional(),
    password: z.string().optional(),
    role_assignments: z.array(zRoleAssignmentInput).optional()
});

/**
 * Re-date one (user, role) grant. PATCH semantics per field: omitted leaves
 * the column untouched. Expiration is the double-Option precedent from
 * providers.rs — explicit `null` clears back to a permanent grant, which a
 * plain Option could not distinguish from "said nothing".
 */
export const zUpdateUserRoleRequest = z.object({
    effective_date: z.iso.date().nullish(),
    expiration_date: z.iso.date().nullish()
});

/**
 * Partial update of a waitlist entry. Only set fields are written. urgency_level ∈
 * {urgent,routine,flexible}; waitlist_status ∈ {active,contacted,scheduled,cancelled,
 * expired} — the UI uses `cancelled` for "remove" and `scheduled` for "promote".
 */
export const zUpdateWaitlistRequest = z.object({
    urgency_level: z.string().nullish(),
    waitlist_status: z.string().nullish()
});

/**
 * One department an account works in — the login-department assignment (F3).
 *
 * Working context and attribution. This grants NO access: patient scope comes
 * from the facility ids on the user's role grants.
 */
export const zUserDepartmentAssignment = z.object({
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    department_name: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    facility_name: z.string(),
    is_primary: z.boolean()
});

export const zUserDepartmentInput = z.object({
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    is_primary: z.boolean().optional()
});

/**
 * The desired assignment set, replacing whatever is stored. The acting
 * administrator is resolved from the caller, never from this body.
 */
export const zSetUserDepartmentsRequest = z.object({
    departments: z.array(zUserDepartmentInput)
});

export const zUserEffectivePermission = z.object({
    permission_code: z.string(),
    permission_name: z.string(),
    sources: z.array(z.string())
});

export const zUserGroupGrantResponse = z.object({
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    facility_name: z.string(),
    group_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    group_role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_name: z.string()
});

export const zUserGroupMemberResponse = z.object({
    full_name: z.string(),
    group_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    username: z.string()
});

export const zUserGroupResponse = z.object({
    grant_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    group_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    health_system_name: z.string(),
    is_active: z.boolean(),
    member_count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    name: z.string()
});

export const zUserGroupDetailResponse = z.object({
    grants: z.array(zUserGroupGrantResponse),
    group: zUserGroupResponse,
    members: z.array(zUserGroupMemberResponse)
});

export const zUserInfo = z.object({
    email: z.string(),
    preferred_language: z.string().nullish(),
    roles: z.array(z.string()),
    user_id: z.string(),
    username: z.string()
});

export const zLoginResponse = z.object({
    access_token: z.string(),
    expires_in: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    mfa_setup_required: z.boolean(),
    refresh_token: z.string(),
    token_type: z.string(),
    user: zUserInfo
});

export const zUserProfileResponse = z.object({
    active_department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    avatar_url: z.string().nullish(),
    department_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    email: z.string(),
    facility_ids: z.array(z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })),
    first_name: z.string(),
    full_name: z.string(),
    has_password: z.boolean(),
    last_name: z.string(),
    mfa_enabled: z.boolean(),
    mobile: z.string().nullish(),
    phone: z.string().nullish(),
    preferred_language: z.string().nullish(),
    roles: z.array(z.string()),
    timezone: z.string().nullish(),
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    username: z.string()
});

export const zUserRoleAssignment = z.object({
    assigned_at: z.iso.datetime().nullish(),
    assigned_by_name: z.string().nullish(),
    assigned_by_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    effective_date: z.iso.date(),
    expiration_date: z.iso.date().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    role_code: z.string(),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_name: z.string(),
    source: z.string()
});

export const zValidateIdRequest = z.object({
    id_type: z.string(),
    id_value: z.string()
});

export const zValidateIdResponse = z.object({
    checksum_mismatch: z.boolean(),
    error: z.string().nullish(),
    valid: z.boolean()
});

/**
 * Database entity for VynaLinkIntegration.
 *
 * Phase 2a added the admin-managed columns
 * (direction, host/port, tls_*; `0110_integration.sql`). Phase 2b reads them here so the
 * start paths can prefer PEM-from-DB over file paths when an admin
 * has rotated certs via the UI.
 */
export const zVynaLinkIntegration = z.object({
    app_nak_retry_max: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    auth_method: z.string().nullish(),
    auth_secret: z.string().nullish(),
    auth_username: z.string().nullish(),
    configuration: z.unknown().optional(),
    connection_status: z.string().nullish(),
    created_at: z.iso.datetime(),
    description: z.string().nullish(),
    direction: z.string().nullish(),
    host: z.string().nullish(),
    inbound_ack_policy: z.string().nullish(),
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    interface_name: z.string(),
    interface_type: z.string().nullish(),
    is_active: z.boolean().nullish(),
    last_error: z.string().nullish(),
    last_heartbeat: z.iso.datetime().nullish(),
    last_message_datetime: z.iso.datetime().nullish(),
    messages_failed_count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    messages_received_count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    messages_sent_count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    modified_at: z.iso.datetime(),
    network_retry_max: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    outbound_ack_policy: z.string().nullish(),
    pending_ack_ttl_secs: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    port: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    processing_timeout_ms: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    reverse_integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    tls_ca_pem: z.string().nullish(),
    tls_cert_pem: z.string().nullish(),
    tls_enabled: z.boolean().nullish(),
    tls_key_pem: z.string().nullish()
});

export const zWaitlistResponse = z.object({
    added_date: z.iso.datetime(),
    mrn: z.string().nullish(),
    notes: z.string().nullish(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    patient_name: z.string().nullish(),
    preferred_date_end: z.iso.date().nullish(),
    preferred_date_start: z.iso.date().nullish(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    provider_name: z.string().nullish(),
    reason_for_visit: z.string().nullish(),
    urgency_level: z.string().nullish(),
    waitlist_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    waitlist_status: z.string().nullish()
});

/**
 * Per-projector lag report (R-3.5)
 */
export const zProjectorLagResponse2 = z.array(zProjectorLagResponse);

export const zIntegrationTimeseriesPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zIntegrationTimeseriesQuery = z.object({
    window_hours: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    bucket_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional()
});

/**
 * Bucketed message-flow series
 */
export const zIntegrationTimeseriesResponse = zTimeseriesResponse;

export const zListInterfaceMessagesQuery = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    direction: z.string().nullish(),
    status: z.string().nullish(),
    message_type: z.string().nullish(),
    message_control_id: z.string().nullish(),
    date_from: z.iso.datetime().nullish(),
    date_to: z.iso.datetime().nullish(),
    include_archive: z.boolean().optional(),
    page: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    page_size: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional()
});

/**
 * Paginated interface-message list
 */
export const zListInterfaceMessagesResponse = zMessageListResponse;

export const zMessageDetailPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zMessageDetailQuery = z.object({
    direction: z.string().nullish()
});

/**
 * Message detail
 */
export const zMessageDetailResponse = zMessageDetail;

export const zAbandonMessageBody = zReasonBody;

export const zAbandonMessagePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zMessageAttemptsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Attempt history newest-first
 */
export const zMessageAttemptsResponse = z.array(zAttemptRow);

export const zResendMessageBody = zReasonBody;

export const zResendMessagePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zRetryMessageBody = zReasonBody;

export const zRetryMessagePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zSkipMessageBody = zReasonBody;

export const zSkipMessagePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Per-integration message-flow stats
 */
export const zIntegrationStatsResponse = z.array(zIntegrationStats);

/**
 * List of dead-lettered outbox events
 */
export const zListDeadLetterResponse = z.array(zDeadLetterEntry);

export const zRequeueDeadLetterPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * LDAP directories
 */
export const zListDirectoriesResponse = z.array(zSsoDirectoryResponse);

export const zCreateDirectoryBody = zCreateSsoDirectoryRequest;

/**
 * LDAP directory created
 */
export const zCreateDirectoryResponse = zSsoDirectoryResponse;

export const zDeleteDirectoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * LDAP directory deleted
 */
export const zDeleteDirectoryResponse = zDeleteKeptResponse;

export const zGetDirectoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * LDAP directory
 */
export const zGetDirectoryResponse = zSsoDirectoryResponse;

export const zUpdateDirectoryBody = zUpdateSsoDirectoryRequest;

export const zUpdateDirectoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * LDAP directory updated
 */
export const zUpdateDirectoryResponse = zSsoDirectoryResponse;

/**
 * SSO email domains
 */
export const zListDomainsResponse = z.array(zSsoDomainResponse);

export const zCreateDomainBody = zCreateSsoDomainRequest;

/**
 * Domain claimed
 */
export const zCreateDomainResponse = zSsoDomainResponse;

export const zDeleteDomainPath = z.object({
    domain: z.string()
});

/**
 * SSO group maps
 */
export const zListGroupMapsResponse = z.array(zSsoGroupMapResponse);

export const zCreateGroupMapBody = zCreateSsoGroupMapRequest;

/**
 * Group map created
 */
export const zCreateGroupMapResponse = zSsoGroupMapResponse;

export const zDeleteGroupMapPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * LDAP group maps
 */
export const zListLdapMapsResponse = z.array(zSsoLdapMapResponse);

export const zCreateLdapMapBody = zCreateSsoLdapMapRequest;

/**
 * LDAP map created
 */
export const zCreateLdapMapResponse = zSsoLdapMapResponse;

export const zDeleteLdapMapPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SSO providers
 */
export const zListProvidersResponse = z.array(zSsoProviderResponse);

export const zCreateProviderBody = zCreateSsoProviderRequest;

/**
 * SSO provider created
 */
export const zCreateProviderResponse = zSsoProviderResponse;

export const zDeleteProviderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SSO provider deleted
 */
export const zDeleteProviderResponse = zDeleteKeptResponse;

export const zGetProviderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SSO provider
 */
export const zGetProviderResponse = zSsoProviderResponse;

export const zUpdateProviderBody = zUpdateSsoProviderRequest;

export const zUpdateProviderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SSO provider updated
 */
export const zUpdateProviderResponse = zSsoProviderResponse;

export const zTestProviderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Connectivity verdict
 */
export const zTestProviderResponse = zSsoTestResult;

/**
 * SCIM tokens
 */
export const zListScimTokensResponse = z.array(zScimTokenResponse);

export const zMintScimTokenBody = zMintScimTokenRequest;

/**
 * SCIM token minted (secret renders once)
 */
export const zMintScimTokenResponse = zMintedScimTokenResponse;

export const zRevokeScimTokenPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SCIM token revoked
 */
export const zRevokeScimTokenResponse = z.void();

export const zListDashboardsQuery = z.object({
    owner_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_shared: z.boolean().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Dashboards
 */
export const zListDashboardsResponse = zPaginatedResponseDashboardResponse;

export const zCreateDashboardBody = zCreateDashboardRequest;

/**
 * Dashboard created
 */
export const zCreateDashboardResponse = zDashboardResponse;

export const zDeleteDashboardPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Dashboard deleted
 */
export const zDeleteDashboardResponse = z.void();

export const zGetDashboardPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Dashboard
 */
export const zGetDashboardResponse = zDashboardResponse;

export const zUpdateDashboardBody = zUpdateDashboardRequest;

export const zUpdateDashboardPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Dashboard updated
 */
export const zUpdateDashboardResponse = zDashboardResponse;

export const zListQualityMeasuresQuery = z.object({
    category: z.string().nullish(),
    measure_type: z.string().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    is_active: z.boolean().nullish(),
    period_start: z.string().nullish(),
    period_end: z.string().nullish()
});

/**
 * Quality measures
 */
export const zListQualityMeasuresResponse = z.array(zQualityMeasureResponse);

export const zExportQrdaCategoryIiiQuery = z.object({
    period_start: z.string(),
    period_end: z.string(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    measure_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

/**
 * QRDA Category III XML download
 */
export const zExportQrdaCategoryIiiResponse = z.string();

export const zListQualityMeasureResultsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zListQualityMeasureResultsQuery = z.object({
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    period_start: z.string().nullish(),
    period_end: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Recorded result rows
 */
export const zListQualityMeasureResultsResponse = zPaginatedResponseQualityMeasureResultResponse;

export const zRecordQualityMeasureResultBody = zRecordQualityMeasureResultRequest;

export const zRecordQualityMeasureResultPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Recorded result row (re-recording a period replaces)
 */
export const zRecordQualityMeasureResultResponse = zQualityMeasureResultResponse;

export const zListReportsQuery = z.object({
    report_type: z.string().nullish(),
    category: z.string().nullish(),
    is_active: z.boolean().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Report definitions
 */
export const zListReportsResponse = zPaginatedResponseReportDefinitionResponse;

export const zRunReportBody = zRunReportRequest;

/**
 * Report result
 */
export const zRunReportResponse = zReportResultResponse;

export const zChangePasswordBody = zChangePasswordRequest;

/**
 * Password changed
 */
export const zChangePasswordResponse = zMessageResponse;

/**
 * Enabled LDAP directories
 */
export const zListDirectories2Response = z.array(zLdapDirectoryInfo);

export const zLoginLdapBody = zLdapLoginRequest;

/**
 * Login successful
 */
export const zLoginLdapResponse = zLoginResponse;

export const zTestDirectoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Test verdict
 */
export const zTestDirectoryResponse = zLdapTestResult;

export const zLoginBody = zLoginRequest;

/**
 * Login successful
 */
export const zLoginResponse2 = zLoginResponse;

/**
 * Logout successful
 */
export const zLogoutResponse = zMessageResponse;

/**
 * Authenticated user profile
 */
export const zGetProfileResponse = zUserProfileResponse;

export const zUpdateProfileBody = zUpdateProfileRequest;

/**
 * Updated profile
 */
export const zUpdateProfileResponse = zUserProfileResponse;

export const zRefreshTokenBody = zRefreshRequest;

/**
 * Token refreshed
 */
export const zRefreshTokenResponse = zRefreshResponse;

/**
 * Setup gate status
 */
export const zSetupStatusResponse2 = zSetupStatusResponse;

export const zSetupClaimBody = zSetupClaimPayload;

/**
 * Install-time admin created
 */
export const zSetupClaimResponse2 = zSetupClaimResponse;

/**
 * SSO session minted
 */
export const zCallbackResponse = zTokenPair;

export const zDiscoverProviderQuery = z.object({
    email: z.unknown()
});

/**
 * The system's SSO provider
 */
export const zDiscoverProviderResponse = zSsoProviderInfo;

export const zLoginRedirectPath = z.object({
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Enabled SSO providers
 */
export const zListProviders2Response = z.array(zSsoProviderInfo);

export const zAcsBody = zSamlAcsForm;

export const zExchangeBody = zSamlExchangeRequest;

/**
 * SAML session minted
 */
export const zExchangeResponse = zTokenPair;

export const zLogin2Path = z.object({
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zMetadataPath = z.object({
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zSwitchDepartmentBody = zSwitchDepartmentRequest;

/**
 * Session re-minted in the new department
 */
export const zSwitchDepartmentResponse2 = zSwitchDepartmentResponse;

export const zGetPatientAccountPath = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Patient account summary
 */
export const zGetPatientAccountResponse = zPatientAccountResponse;

export const zSearchChargeMasterQuery = z.object({
    code: z.string().nullish(),
    description: z.string().nullish(),
    category: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated charge-master entries
 */
export const zSearchChargeMasterResponse = zPaginatedResponseChargeMasterResponse;

export const zListChargesQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    charge_status: z.string().nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    patient_search: z.string().nullish()
});

/**
 * Paginated charge list
 */
export const zListChargesResponse = zPaginatedResponseChargeResponse;

export const zCreateChargeBody = zCreateChargeRequest;

/**
 * Charge created
 */
export const zCreateChargeResponse = zChargeResponse;

export const zVoidChargePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Charge voided
 */
export const zVoidChargeResponse = zChargeResponse;

export const zListClaimsQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    claim_status: z.string().nullish(),
    payer_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    payer_search: z.string().nullish()
});

/**
 * Paginated claim list
 */
export const zListClaimsResponse = zPaginatedResponseClaimResponse;

export const zCreateClaimBody = zCreateClaimRequest;

/**
 * Claim created
 */
export const zCreateClaimResponse = zClaimResponse;

export const zSubmitClaimPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Claim submitted
 */
export const zSubmitClaimResponse = zClaimResponse;

export const zListDenialsQuery = z.object({
    status: z.string().nullish(),
    assigned_to_me: z.boolean().nullish()
});

/**
 * Denied-claim worklist
 */
export const zListDenialsResponse = zDenialsResponse;

export const zUpdateDenialStatusBody = zUpdateDenialStatusRequest;

export const zUpdateDenialStatusPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Transition applied
 */
export const zUpdateDenialStatusResponse2 = zUpdateDenialStatusResponse;

export const zListPaymentsQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    claim_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    payment_status: z.string().nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    patient_search: z.string().nullish()
});

/**
 * Paginated payment list
 */
export const zListPaymentsResponse = zPaginatedResponsePaymentResponse;

export const zCreatePaymentBody = zCreatePaymentRequest;

/**
 * Payment recorded
 */
export const zCreatePaymentResponse = zPaymentResponse;

/**
 * Statement history (most recent 500)
 */
export const zListStatementsResponse = zStatementHistoryResponse;

export const zGenerateStatementBody = zGenerateStatementRequest;

/**
 * Statement generated
 */
export const zGenerateStatementResponse = zStatementResponse;

export const zPreviewStatementQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    date_from: z.string().nullish(),
    date_to: z.string().nullish()
});

/**
 * Statement preview
 */
export const zPreviewStatementResponse = zStatementPreviewResponse;

export const zCreateBreakGlassBody = zBreakGlassRequest;

/**
 * Break-glass access granted
 */
export const zCreateBreakGlassResponse = zBreakGlassResponse;

export const zListEncountersQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_status: z.string().nullish(),
    encounter_class: z.string().nullish(),
    encounter_type: z.string().nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of encounters
 */
export const zListEncountersResponse = zPaginatedResponseEncounterResponse;

export const zCreateEncounterBody = zCreateEncounterRequest;

/**
 * Encounter created
 */
export const zCreateEncounterResponse = zEncounterResponse;

export const zDeleteEncounterPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Encounter deleted
 */
export const zDeleteEncounterResponse = z.void();

export const zGetEncounterPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Encounter found
 */
export const zGetEncounterResponse = zEncounterResponse;

export const zUpdateEncounterBody = zUpdateEncounterRequest;

export const zUpdateEncounterPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Encounter updated
 */
export const zUpdateEncounterResponse = zEncounterResponse;

export const zListClassHistoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Class history
 */
export const zListClassHistoryResponse = z.array(zClassHistoryEntry);

export const zRequestClassChangeBody = zClassChangeRequest;

export const zRequestClassChangePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order placed
 */
export const zRequestClassChangeResponse = zClassChangeResponse;

export const zConcurClassChangePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Concurred and applied
 */
export const zConcurClassChangeResponse = zClassChangeResponse;

export const zListDiagnosesPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Encounter diagnoses
 */
export const zListDiagnosesResponse = z.array(zEncounterDiagnosisResponse);

export const zAddDiagnosisBody = zAddDiagnosisRequest;

export const zAddDiagnosisPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Diagnosis recorded
 */
export const zAddDiagnosisResponse = zEncounterDiagnosisResponse;

export const zDischargeEncounterBody = zDischargeRequest;

export const zDischargeEncounterPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Patient discharged
 */
export const zDischargeEncounterResponse = zEncounterResponse;

export const zTransferEncounterBody = zTransferRequest;

export const zTransferEncounterPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Patient transferred
 */
export const zTransferEncounterResponse = zTransferResponse;

export const zListTransfersPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Transfer history
 */
export const zListTransfersResponse = z.array(zTransferResponse);

/**
 * SMART App Launch discovery doc
 */
export const zSmartConfigurationResponse = zSmartConfiguration;

/**
 * Configured CDS Hooks services
 */
export const zListCdsServicesResponse = z.record(z.string(), z.unknown());

export const zInvokeCdsServiceBody = z.record(z.string(), z.unknown());

export const zInvokeCdsServicePath = z.object({
    service_id: z.string()
});

/**
 * CDS hook response with zero or more cards
 */
export const zInvokeCdsServiceResponse = z.record(z.string(), z.unknown());

export const zProcessBundleBody = zFhirBundle;

/**
 * Transaction-response or batch-response Bundle
 */
export const zProcessBundleResponse = zFhirBundle;

export const zKickoffSystemExportQuery = z.object({
    _type: z.string().nullish(),
    _since: z.string().nullish(),
    _outputFormat: z.string().nullish(),
    includeAssociatedData: z.string().nullish()
});

export const zExportFilePath = z.object({
    job_id: z.string(),
    resource_type: z.string()
});

/**
 * NDJSON stream (application/fhir+ndjson)
 */
export const zExportFileResponse = z.string();

export const zCancelExportPath = z.object({
    job_id: z.string()
});

export const zExportStatusPath = z.object({
    job_id: z.string()
});

export const zExportStatusResponse2 = z.union([
    zExportStatusResponse,
    z.unknown()
]);

export const zKickoffGroupExportPath = z.object({
    group_id: z.string()
});

export const zKickoffGroupExportQuery = z.object({
    _type: z.string().nullish(),
    _since: z.string().nullish(),
    _outputFormat: z.string().nullish(),
    includeAssociatedData: z.string().nullish()
});

export const zKickoffPatientExportQuery = z.object({
    _type: z.string().nullish(),
    _since: z.string().nullish(),
    _outputFormat: z.string().nullish(),
    includeAssociatedData: z.string().nullish()
});

export const zPatientMatchBody = zPatientMatchRequest;

/**
 * Match candidates Bundle (each entry includes a `search.score`)
 */
export const zPatientMatchResponse = zFhirBundle;

export const zPatientEverythingPath = z.object({
    id: z.string()
});

export const zPatientEverythingQuery = z.object({
    _crossFacility: z.boolean().nullish()
});

/**
 * Patient compartment Bundle
 */
export const zPatientEverythingResponse = zFhirBundle;

export const zPatientHealthCardPath = z.object({
    id: z.string()
});

/**
 * SMART Health Card (unsigned, numeric-string encoding)
 */
export const zPatientHealthCardResponse = z.record(z.string(), z.unknown());

export const zPatientSummaryPath = z.object({
    id: z.string()
});

/**
 * IPS document Bundle (type=document)
 */
export const zPatientSummaryResponse2 = z.record(z.string(), z.unknown());

export const zReadHistorySystemQuery = z.object({
    _count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    _since: z.string().nullish(),
    _at: z.string().nullish()
});

/**
 * FHIR history Bundle across all resource types
 */
export const zReadHistorySystemResponse = z.record(z.string(), z.unknown());

export const zConditionalDeleteResourcePath = z.object({
    resource_type: z.string()
});

export const zConditionalDeleteResourceQuery = z.object({
    identifier: z.string().nullish()
});

/**
 * Resource deleted
 */
export const zConditionalDeleteResourceResponse = z.void();

export const zSearchResourcePath = z.object({
    resource_type: z.string()
});

export const zSearchResourceQuery = z.object({
    _id: z.string().nullish(),
    _count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    _offset: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    _sort: z.string().nullish(),
    _include: z.string().nullish(),
    _revinclude: z.string().nullish(),
    _summary: z.string().nullish(),
    _elements: z.string().nullish(),
    identifier: z.string().nullish(),
    name: z.string().nullish(),
    family: z.string().nullish(),
    given: z.string().nullish(),
    birthdate: z.string().nullish(),
    gender: z.string().nullish(),
    patient: z.string().nullish(),
    subject: z.string().nullish(),
    practitioner: z.string().nullish(),
    organization: z.string().nullish(),
    date: z.string().nullish(),
    status: z.string().nullish(),
    code: z.string().nullish(),
    category: z.string().nullish()
});

/**
 * FHIR searchset Bundle
 */
export const zSearchResourceResponse = zFhirBundle;

export const zCreateResourceBody = z.record(z.string(), z.unknown());

export const zCreateResourcePath = z.object({
    resource_type: z.string()
});

/**
 * Resource created (Location header set to canonical URL)
 */
export const zCreateResourceResponse = z.record(z.string(), z.unknown());

export const zConditionalUpdateResourceBody = z.record(z.string(), z.unknown());

export const zConditionalUpdateResourcePath = z.object({
    resource_type: z.string()
});

export const zConditionalUpdateResourceQuery = z.object({
    identifier: z.string().nullish()
});

export const zConditionalUpdateResourceResponse = z.union([
    z.record(z.string(), z.unknown()),
    z.record(z.string(), z.unknown())
]);

export const zReadHistoryTypePath = z.object({
    resource_type: z.string()
});

export const zReadHistoryTypeQuery = z.object({
    _count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    _since: z.string().nullish(),
    _at: z.string().nullish()
});

/**
 * FHIR history Bundle for the resource type
 */
export const zReadHistoryTypeResponse = z.record(z.string(), z.unknown());

export const zDeleteResourcePath = z.object({
    resource_type: z.string(),
    id: z.string()
});

/**
 * Resource deleted
 */
export const zDeleteResourceResponse = z.void();

export const zReadResourcePath = z.object({
    resource_type: z.string(),
    id: z.string()
});

/**
 * FHIR resource (shape varies by resource_type)
 */
export const zReadResourceResponse = z.record(z.string(), z.unknown());

export const zPatchResourceBody = z.record(z.string(), z.unknown());

export const zPatchResourcePath = z.object({
    resource_type: z.string(),
    id: z.string()
});

/**
 * Patch applied
 */
export const zPatchResourceResponse = z.record(z.string(), z.unknown());

export const zUpdateResourceBody = z.record(z.string(), z.unknown());

export const zUpdateResourcePath = z.object({
    resource_type: z.string(),
    id: z.string()
});

/**
 * Resource updated
 */
export const zUpdateResourceResponse = z.record(z.string(), z.unknown());

export const zReadHistoryInstancePath = z.object({
    resource_type: z.string(),
    id: z.string()
});

export const zReadHistoryInstanceQuery = z.object({
    _count: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    _since: z.string().nullish(),
    _at: z.string().nullish()
});

/**
 * FHIR history Bundle for the resource instance
 */
export const zReadHistoryInstanceResponse = z.record(z.string(), z.unknown());

export const zReadHistoryVersionPath = z.object({
    resource_type: z.string(),
    id: z.string(),
    version_id: z.string()
});

/**
 * FHIR resource at the requested version
 */
export const zReadHistoryVersionResponse = z.record(z.string(), z.unknown());

export const zSearchResourceR5Path = z.object({
    resource_type: z.string()
});

export const zSearchResourceR5Query = z.object({
    _id: z.string().nullish(),
    _count: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    _offset: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    _sort: z.string().nullish(),
    _include: z.string().nullish(),
    _revinclude: z.string().nullish(),
    _summary: z.string().nullish(),
    _elements: z.string().nullish(),
    identifier: z.string().nullish(),
    name: z.string().nullish(),
    family: z.string().nullish(),
    given: z.string().nullish(),
    birthdate: z.string().nullish(),
    gender: z.string().nullish(),
    patient: z.string().nullish(),
    subject: z.string().nullish(),
    practitioner: z.string().nullish(),
    organization: z.string().nullish(),
    date: z.string().nullish(),
    status: z.string().nullish(),
    code: z.string().nullish(),
    category: z.string().nullish()
});

/**
 * FHIR R5 searchset Bundle
 */
export const zSearchResourceR5Response = zFhirBundle;

export const zCreateResourceR5Body = z.record(z.string(), z.unknown());

export const zCreateResourceR5Path = z.object({
    resource_type: z.string()
});

/**
 * Resource created
 */
export const zCreateResourceR5Response = z.record(z.string(), z.unknown());

export const zReadResourceR5Path = z.object({
    resource_type: z.string(),
    id: z.string()
});

/**
 * FHIR R5 resource
 */
export const zReadResourceR5Response = z.record(z.string(), z.unknown());

/**
 * Registered SMART apps
 */
export const zListSmartAppsResponse = z.array(zSmartAppRow);

export const zCreateSmartAppBody = zCreateSmartAppRequest;

/**
 * SMART app created; client_secret returned exactly once
 */
export const zCreateSmartAppResponse2 = zCreateSmartAppResponse;

export const zDeleteSmartAppPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SMART app revoked (is_active flipped)
 */
export const zDeleteSmartAppResponse = z.void();

export const zUpdateSmartAppBody = zUpdateSmartAppRequest;

export const zUpdateSmartAppPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * SMART app updated
 */
export const zUpdateSmartAppResponse = zSmartAppRow;

export const zRotateSmartAppSecretPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * New client_secret returned exactly once
 */
export const zRotateSmartAppSecretResponse = zRotateSecretResponse;

export const zListMessagesQuery = z.object({
    message_type: z.string().optional(),
    message_event: z.string().optional(),
    processing_status: z.string().optional(),
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    source_system: z.string().optional(),
    limit: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    offset: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional()
});

/**
 * List of HL7 messages
 */
export const zListMessagesResponse = zApiResponseVecHl7MessageResponse;

export const zReceiveMessageBody = zCreateHl7MessageRequest;

/**
 * Message received and queued for processing
 */
export const zReceiveMessageResponse = zApiResponseHl7MessageResponse;

export const zGetMessageByControlIdPath = z.object({
    control_id: z.string()
});

/**
 * HL7 message details
 */
export const zGetMessageByControlIdResponse = zApiResponseHl7MessageResponse;

export const zGetMessagePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * HL7 message details
 */
export const zGetMessageResponse = zApiResponseHl7MessageResponse;

/**
 * HL7 message statistics
 */
export const zGetStatsResponse = zApiResponseHl7MessageStats;

/**
 * List of HoH clients
 */
export const zListClientsResponse = z.array(zHohClientStatus);

export const zCreateClientBody = zCreateHohClientRequest;

export const zRemoveClientPath = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zSendMessageBody = zSendHohMessageRequest;

export const zSendMessagePath = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Message sent
 */
export const zSendMessageResponse2 = zSendHohMessageResponse;

export const zGetClientStatusPath = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Client status
 */
export const zGetClientStatusResponse = zHohClientStatus;

/**
 * List of running HoH servers
 */
export const zListServersResponse = z.array(zHohServerStatus);

export const zStartServerBody = zStartHohServerRequest;

export const zStopServerPath = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zGetServerStatusPath = z.object({
    integration_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Server status
 */
export const zGetServerStatusResponse = zHohServerStatus;

export const zListMedicationsQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    medication_name: z.string().nullish(),
    is_verified: z.boolean().nullish(),
    is_discontinued: z.boolean().nullish(),
    is_controlled: z.boolean().nullish(),
    order_status: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of medication orders
 */
export const zListMedicationsResponse = zPaginatedResponseMedicationResponse;

export const zCreateMedicationBody = zCreateMedicationRequest;

/**
 * Medication order created
 */
export const zCreateMedicationResponse = zMedicationWithCdsResponse;

export const zGetMarScheduleQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    date: z.string().nullish()
});

/**
 * MAR schedule for patient
 */
export const zGetMarScheduleResponse = zMarScheduleResponse;

export const zGetMedicationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Medication order found
 */
export const zGetMedicationResponse = zMedicationResponse;

export const zRecordAdministrationBody = zAdministrationRequest;

export const zRecordAdministrationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Administration recorded
 */
export const zRecordAdministrationResponse = zAdministrationResponse;

export const zListAdministrationsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zListAdministrationsQuery = z.object({
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of administrations
 */
export const zListAdministrationsResponse = zPaginatedResponseAdministrationResponse;

export const zDiscontinueMedicationBody = zDiscontinueMedicationRequest;

export const zDiscontinueMedicationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Medication order discontinued
 */
export const zDiscontinueMedicationResponse = zMedicationResponse;

export const zListDiscrepanciesPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Discrepancies for this order
 */
export const zListDiscrepanciesResponse = z.array(zDiscrepancyResponse);

export const zResolveClarificationBody = zResolveClarificationRequest;

export const zResolveClarificationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    discrepancy_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Clarification resolved
 */
export const zResolveClarificationResponse = zMedicationResponse;

export const zListDispensesPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zListDispensesQuery = z.object({
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional()
});

/**
 * Dispenses for this order
 */
export const zListDispensesResponse = z.array(zDispenseResponse);

export const zRecordDispenseBody2 = zRecordDispenseBody;

export const zRecordDispensePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Dispense recorded
 */
export const zRecordDispenseResponse = zDispenseResponse;

export const zDoubleCheckMedicationBody = zDoubleCheckRequest;

export const zDoubleCheckMedicationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zOverrideVerificationBody = zOverrideVerificationRequest;

export const zOverrideVerificationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order advanced without verification
 */
export const zOverrideVerificationResponse = zMedicationResponse;

export const zResumeMedicationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order resumed
 */
export const zResumeMedicationResponse = zMedicationResponse;

export const zSuspendMedicationBody = zSuspendMedicationRequest;

export const zSuspendMedicationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order held
 */
export const zSuspendMedicationResponse = zMedicationResponse;

export const zVerifyMedicationBody = zPharmacistVerifyRequest;

export const zVerifyMedicationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Medication order verified by pharmacist
 */
export const zVerifyMedicationResponse = zMedicationResponse;

/**
 * List of clients
 */
export const zListClients2Response = zClientListResponse;

export const zCreateClient2Body = zCreateClientRequest;

/**
 * Client created
 */
export const zCreateClient2Response = zClientStatus;

export const zRemoveClient2Path = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Client removed
 */
export const zRemoveClient2Response = z.void();

export const zGetClientStatus2Path = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Client status
 */
export const zGetClientStatus2Response = zClientStatus;

export const zConnectClientPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Client connected
 */
export const zConnectClientResponse = zClientStatus;

export const zDisconnectClientPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Client disconnected
 */
export const zDisconnectClientResponse = zClientStatus;

export const zSendMessage2Body = zSendMessageRequest;

export const zSendMessage2Path = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Message sent
 */
export const zSendMessage2Response = zSendMessageResponse;

/**
 * List of integrations
 */
export const zListIntegrationsResponse = zIntegrationListResponse;

export const zGetIntegrationPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Integration details
 */
export const zGetIntegrationResponse = zVynaLinkIntegration;

export const zGetIntegrationStatusPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Integration status
 */
export const zGetIntegrationStatusResponse = zIntegrationStatusResponse;

/**
 * List of running servers
 */
export const zListServers2Response = zServerListResponse;

export const zStartServer2Body = zStartServerRequest;

/**
 * Server started
 */
export const zStartServer2Response = zServerStatus;

export const zStopServer2Path = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Server stopped
 */
export const zStopServer2Response = z.void();

export const zGetServerStatus2Path = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Server status
 */
export const zGetServerStatus2Response = zServerStatus;

export const zListNotesQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    note_type: z.string().nullish(),
    status: z.string().nullish(),
    unsigned: z.boolean().nullish(),
    author_user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of clinical notes
 */
export const zListNotesResponse = zPaginatedResponseClinicalNoteResponse;

export const zCreateNoteBody = zCreateNoteRequest;

/**
 * Clinical note created
 */
export const zCreateNoteResponse = zClinicalNoteResponse;

export const zListSmartPhrasesQuery = z.object({
    category: z.string().nullish(),
    search: z.string().nullish()
});

/**
 * List of smart phrases
 */
export const zListSmartPhrasesResponse = z.array(zSmartPhraseResponse);

export const zCreateSmartPhraseBody = zCreateSmartPhraseRequest;

/**
 * Smart phrase created
 */
export const zCreateSmartPhraseResponse = zSmartPhraseResponse;

export const zExpandSmartPhraseBody = zExpandSmartPhraseRequest;

/**
 * Phrase expanded
 */
export const zExpandSmartPhraseResponse2 = zExpandSmartPhraseResponse;

export const zDeleteSmartPhrasePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Smart phrase deleted
 */
export const zDeleteSmartPhraseResponse = z.void();

export const zUpdateSmartPhraseBody = zUpdateSmartPhraseRequest;

export const zUpdateSmartPhrasePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Smart phrase updated
 */
export const zUpdateSmartPhraseResponse = zSmartPhraseResponse;

export const zListTemplatesQuery = z.object({
    note_type: z.string().nullish(),
    specialty: z.string().nullish(),
    is_active: z.boolean().nullish()
});

/**
 * List of note templates
 */
export const zListTemplatesResponse = z.array(zNoteTemplateResponse);

export const zCreateTemplateBody = zCreateTemplateRequest;

/**
 * Template created
 */
export const zCreateTemplateResponse = zNoteTemplateResponse;

export const zGetTemplatePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Note template found
 */
export const zGetTemplateResponse = zNoteTemplateResponse;

export const zUpdateTemplateBody = zUpdateTemplateRequest;

export const zUpdateTemplatePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Template updated
 */
export const zUpdateTemplateResponse = zNoteTemplateResponse;

export const zGetNotePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Clinical note found
 */
export const zGetNoteResponse = zClinicalNoteResponse;

export const zUpdateNoteBody = zUpdateNoteRequest;

export const zUpdateNotePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Clinical note updated
 */
export const zUpdateNoteResponse = zClinicalNoteResponse;

export const zAmendNoteBody = zAmendNoteRequest;

export const zAmendNotePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Amendment created (new note version)
 */
export const zAmendNoteResponse = zClinicalNoteResponse;

export const zCosignNoteBody = zCosignNoteRequest;

export const zCosignNotePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Note co-signed successfully
 */
export const zCosignNoteResponse = zClinicalNoteResponse;

export const zSignNoteBody = zSignNoteRequest;

export const zSignNotePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Note signed successfully
 */
export const zSignNoteResponse = zClinicalNoteResponse;

export const zListOrdersQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    order_type: z.string().nullish(),
    order_status: z.string().nullish(),
    priority: z.string().nullish(),
    ordering_provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    search: z.string().nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of orders
 */
export const zListOrdersResponse = zPaginatedResponseOrderResponse;

export const zCreateOrderBody = zCreateOrderRequest;

/**
 * Order created
 */
export const zCreateOrderResponse = zOrderWithCdsResponse;

export const zDeleteOrderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order deleted
 */
export const zDeleteOrderResponse = z.void();

export const zGetOrderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order found
 */
export const zGetOrderResponse = zOrderResponse;

export const zUpdateOrderBody = zUpdateOrderRequest;

export const zUpdateOrderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order updated
 */
export const zUpdateOrderResponse = zOrderResponse;

export const zCancelOrderBody = zCancelOrderRequest;

export const zCancelOrderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order cancelled
 */
export const zCancelOrderResponse = zOrderResponse;

export const zCompleteOrderPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Order completed
 */
export const zCompleteOrderResponse = zOrderResponse;

export const zListPatientsQuery = z.object({
    q: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    status: z.string().nullish(),
    cursor: z.string().nullish(),
    limit: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of patients
 */
export const zListPatientsResponse = zPaginatedResponsePatientResponse;

export const zCreatePatientBody = zCreatePatientRequest;

/**
 * Patient created
 */
export const zCreatePatientResponse = zPatientWithDuplicatesResponse;

export const zListDuplicatesQuery = z.object({
    status: z.string().nullish(),
    min_score: z.number().nullish(),
    page: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    per_page: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

/**
 * Candidate duplicate pairs
 */
export const zListDuplicatesResponse = zDuplicateWorklistResponse;

export const zDismissDuplicateBody = zDismissRequest;

export const zDismissDuplicatePath = z.object({
    candidate_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Decision recorded
 */
export const zDismissDuplicateResponse = zDismissResponse;

export const zListMyPatientsQuery = z.object({
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

/**
 * Caller's my-patients panel
 */
export const zListMyPatientsResponse = zPaginatedResponseMyPatientResponse;

export const zValidateNationalIdBody = zValidateIdRequest;

/**
 * Validation result
 */
export const zValidateNationalIdResponse = zValidateIdResponse;

export const zDeletePatientPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Patient soft-deleted
 */
export const zDeletePatientResponse = z.void();

export const zGetPatientPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Patient found
 */
export const zGetPatientResponse = zPatientDetailResponse;

export const zUpdatePatientBody = zUpdatePatientRequest;

export const zUpdatePatientPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Patient updated
 */
export const zUpdatePatientResponse = zPatientDetailResponse;

export const zExportCcdaPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zExportCcdaQuery = z.object({
    type: z.string().optional(),
    reason: z.string().nullish(),
    encounter: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    hospital_course: z.string().nullish(),
    plan_of_treatment: z.string().nullish(),
    consultations: z.string().nullish()
});

/**
 * C-CDA 2.1 XML download
 */
export const zExportCcdaResponse = z.string();

/**
 * C-CDA XML document
 */
export const zImportCcdaBody = z.string();

export const zImportCcdaPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Structured preview with the staging id
 */
export const zImportCcdaResponse = z.record(z.string(), z.unknown());

export const zListImportsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zListImportsQuery = z.object({
    status: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).optional()
});

/**
 * Staged-import queue
 */
export const zListImportsResponse = zCcdaImportListResponse;

export const zGetImportPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    import_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Import with its staged entries
 */
export const zGetImportResponse = zCcdaImportDetailResponse;

export const zReviewImportEntryBody = zReviewEntryBody;

export const zReviewImportEntryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    import_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    entry_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Reviewed entry
 */
export const zReviewImportEntryResponse = zCcdaImportEntryResponse;

export const zListPortalAppointmentsQuery = z.object({
    status: z.string().nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated portal appointments
 */
export const zListPortalAppointmentsResponse = zPaginatedResponsePortalAppointmentResponse;

export const zListFormsQuery = z.object({
    form_type: z.string().nullish(),
    status: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated portal forms
 */
export const zListFormsResponse = zPaginatedResponsePortalFormResponse;

export const zSubmitFormBody = zSubmitFormRequest;

/**
 * Form submitted
 */
export const zSubmitFormResponse = zPortalFormResponse;

export const zPortalLoginBody = zPortalLoginRequest;

/**
 * Login succeeded
 */
export const zPortalLoginResponse2 = zPortalLoginResponse;

export const zListPortalMessagesQuery = z.object({
    thread_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    category: z.string().nullish(),
    is_read: z.boolean().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated portal messages
 */
export const zListPortalMessagesResponse = zPaginatedResponsePortalMessageResponse;

export const zSendMessage3Body = zSendMessageRequest;

/**
 * Message sent
 */
export const zSendMessage3Response = zPortalMessageResponse;

export const zPortalRegisterBody = zPortalRegisterRequest;

/**
 * Portal account created (email verification email sent)
 */
export const zPortalRegisterResponse = zPortalUserResponse;

export const zResendVerificationBody = zResendVerificationRequest;

/**
 * Resend accepted — a verification email follows when an unverified account holds that email
 */
export const zResendVerificationResponse = z.record(z.string(), z.unknown());

export const zListPortalResultsQuery = z.object({
    result_status: z.string().nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    is_abnormal: z.boolean().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated portal results
 */
export const zListPortalResultsResponse = zPaginatedResponsePortalResultResponse;

/**
 * Patient summary
 */
export const zGetPatientSummaryResponse = zPatientSummaryResponse;

/**
 * Portal user profile
 */
export const zGetPortalUserResponse = zPortalUserResponse;

export const zUpdatePortalUserBody = zUpdatePortalUserRequest;

/**
 * Portal user updated
 */
export const zUpdatePortalUserResponse = zPortalUserResponse;

export const zVerifyEmailQuery = z.object({
    token: z.string()
});

/**
 * Email verified — caller may now log in
 */
export const zVerifyEmailResponse = z.record(z.string(), z.unknown());

/**
 * Role categories
 */
export const zListCategoriesResponse = z.array(zRoleCategoryResponse);

export const zCreateCategoryBody = zCreateCategoryRequest;

/**
 * Category created
 */
export const zCreateCategoryResponse = zRoleCategoryResponse;

export const zDeleteCategoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Category deleted
 */
export const zDeleteCategoryResponse = z.record(z.string(), z.unknown());

export const zGetCategoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role category
 */
export const zGetCategoryResponse = zRoleCategoryResponse;

export const zUpdateCategoryBody = zUpdateCategoryRequest;

export const zUpdateCategoryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Category updated
 */
export const zUpdateCategoryResponse = z.record(z.string(), z.unknown());

export const zListCategoryPermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Permissions assignable in this category
 */
export const zListCategoryPermissionsResponse = z.array(zPermissionResponse);

export const zSetCategoryPermissionsBody = zSetCategoryPermissionsRequest;

export const zSetCategoryPermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Category permissions replaced
 */
export const zSetCategoryPermissionsResponse = z.record(z.string(), z.unknown());

/**
 * User groups
 */
export const zListGroupsResponse = z.array(zUserGroupResponse);

export const zCreateGroupBody = zCreateUserGroupRequest;

/**
 * User group created
 */
export const zCreateGroupResponse = zUserGroupResponse;

export const zDeleteGroupPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * User group deleted
 */
export const zDeleteGroupResponse = zDeleteUserGroupResponse;

export const zGetGroupPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * User group detail
 */
export const zGetGroupResponse = zUserGroupDetailResponse;

export const zUpdateGroupBody = zUpdateUserGroupRequest;

export const zUpdateGroupPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * User group updated
 */
export const zUpdateGroupResponse = zUserGroupResponse;

export const zAddGroupGrantBody = zAddGroupGrantRequest;

export const zAddGroupGrantPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Grant added
 */
export const zAddGroupGrantResponse = zUserGroupGrantResponse;

export const zRemoveGroupGrantPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    grant_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Grant removed
 */
export const zRemoveGroupGrantResponse = z.record(z.string(), z.unknown());

export const zAddGroupMemberBody = zAddGroupMemberRequest;

export const zAddGroupMemberPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Member added
 */
export const zAddGroupMemberResponse = zUserGroupMemberResponse;

export const zRemoveGroupMemberPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Member removed
 */
export const zRemoveGroupMemberResponse = z.record(z.string(), z.unknown());

/**
 * Permission × role matrix for the admin UI
 */
export const zGetAccessMatrixResponse = zAccessMatrixResponse;

export const zListPermissionsQuery = z.object({
    resource: z.string().nullish(),
    action: z.string().nullish(),
    search: z.string().nullish()
});

/**
 * Permissions catalogue
 */
export const zListPermissionsResponse = z.array(zPermissionResponse);

export const zCreatePermissionBody = zCreatePermissionRequest;

/**
 * Permission created
 */
export const zCreatePermissionResponse = zPermissionResponse;

export const zDeletePermissionPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Permission deleted
 */
export const zDeletePermissionResponse = z.record(z.string(), z.unknown());

export const zUpdatePermissionBody = zUpdatePermissionRequest;

export const zUpdatePermissionPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Permission updated
 */
export const zUpdatePermissionResponse = z.record(z.string(), z.unknown());

/**
 * Review campaigns with decision counts
 */
export const zListCampaignsResponse = z.array(zReviewCampaignResponse);

export const zCreateCampaignBody = zCreateReviewCampaignRequest;

/**
 * Campaign created and grants snapshotted
 */
export const zCreateCampaignResponse = zReviewCampaignResponse;

export const zDeleteCampaignPath = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Open campaign deleted
 */
export const zDeleteCampaignResponse = z.record(z.string(), z.unknown());

export const zGetCampaignPath = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Campaign with its items
 */
export const zGetCampaignResponse = zReviewCampaignDetailResponse;

export const zCloseCampaignPath = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Campaign closed
 */
export const zCloseCampaignResponse = zReviewCampaignResponse;

export const zCertifyItemPath = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    item_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Item certified
 */
export const zCertifyItemResponse = zReviewItemResponse;

export const zRevokeItemPath = z.object({
    campaign_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    item_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Grant revoked and item marked
 */
export const zRevokeItemResponse = zReviewItemResponse;

/**
 * Roles
 */
export const zListRolesResponse = z.array(zRoleDetailResponse);

export const zCreateRoleBody = zCreateRoleRequest;

/**
 * Role created
 */
export const zCreateRoleResponse = zRoleDetailResponse;

export const zDeleteRolePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role deleted
 */
export const zDeleteRoleResponse = z.record(z.string(), z.unknown());

export const zGetRolePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role detail
 */
export const zGetRoleResponse = zRoleDetailResponse;

export const zUpdateRoleBody = zUpdateRoleRequest;

export const zUpdateRolePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role updated
 */
export const zUpdateRoleResponse = z.record(z.string(), z.unknown());

export const zListDeniedPermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Denied permissions explicitly subtracted from this role
 */
export const zListDeniedPermissionsResponse = z.array(zDeniedPermissionResponse);

export const zSetDeniedPermissionsBody = zSetDeniedPermissionsRequest;

export const zSetDeniedPermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Denied permissions replaced
 */
export const zSetDeniedPermissionsResponse = z.record(z.string(), z.unknown());

export const zGetEffectivePermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Effective permissions (own + inherited from parent role)
 */
export const zGetEffectivePermissionsResponse = z.array(zEffectivePermission);

export const zListRolePermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Permissions granted to role
 */
export const zListRolePermissionsResponse = z.array(zPermissionResponse);

export const zSetRolePermissionsBody = zSetRolePermissionsRequest;

export const zSetRolePermissionsPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role permissions replaced
 */
export const zSetRolePermissionsResponse = z.record(z.string(), z.unknown());

/**
 * Admin user list with joined roles
 */
export const zListUsersResponse = z.array(zAdminUserRow);

export const zCreateUserBody = zCreateUserPayload;

/**
 * User created
 */
export const zCreateUserResponse = zAdminUserRow;

export const zUpdateUserBody = zUpdateUserPayload;

export const zUpdateUserPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * User updated
 */
export const zUpdateUserResponse = zAdminUserRow;

export const zListUserDepartmentsPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * The account's login departments
 */
export const zListUserDepartmentsResponse = z.array(zUserDepartmentAssignment);

export const zSetUserDepartmentsBody = zSetUserDepartmentsRequest;

export const zSetUserDepartmentsPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * The stored assignment set
 */
export const zSetUserDepartmentsResponse = z.array(zUserDepartmentAssignment);

export const zSetUserPasswordBody = zSetUserPasswordPayload;

export const zSetUserPasswordPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Password reset
 */
export const zSetUserPasswordResponse = zAdminUserRow;

export const zGetUserPermissionsPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Effective permissions for user (union over assigned roles minus denials)
 */
export const zGetUserPermissionsResponse = z.array(zUserEffectivePermission);

export const zListUserRolesPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Roles assigned to user (with optional facility scope)
 */
export const zListUserRolesResponse = z.array(zUserRoleAssignment);

export const zAssignUserRoleBody = zAssignRoleRequest;

export const zAssignUserRolePath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role assigned to user
 */
export const zAssignUserRoleResponse = z.record(z.string(), z.unknown());

export const zRemoveUserRolePath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Role unassigned from user
 */
export const zRemoveUserRoleResponse = z.record(z.string(), z.unknown());

export const zUpdateUserRoleBody = zUpdateUserRoleRequest;

export const zUpdateUserRolePath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }),
    role_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Grant re-dated
 */
export const zUpdateUserRoleResponse = z.record(z.string(), z.unknown());

export const zSetUserStatusBody = zSetUserStatusPayload;

export const zSetUserStatusPath = z.object({
    user_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Status flipped
 */
export const zSetUserStatusResponse = zAdminUserRow;

export const zListResultsQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    encounter_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    order_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    result_type: z.string().nullish(),
    result_status: z.string().nullish(),
    is_critical: z.boolean().nullish(),
    critical_acknowledged: z.boolean().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * List of results
 */
export const zListResultsResponse = zPaginatedResponseResultResponse;

export const zCreateResultBody = zCreateResultRequest;

/**
 * Result created
 */
export const zCreateResultResponse = zResultResponse;

export const zAcknowledgeCriticalBatchBody = zBatchAcknowledgeCriticalRequest;

/**
 * Critical results acknowledged
 */
export const zAcknowledgeCriticalBatchResponse = zBatchAcknowledgeCriticalResponse;

export const zDeleteResultPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Result deleted
 */
export const zDeleteResultResponse = z.void();

export const zGetResultPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Result found
 */
export const zGetResultResponse = zResultResponse;

export const zUpdateResultBody = zUpdateResultRequest;

export const zUpdateResultPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Result updated
 */
export const zUpdateResultResponse = zResultResponse;

export const zAcknowledgeCriticalPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Critical result acknowledged
 */
export const zAcknowledgeCriticalResponse = zResultResponse;

export const zListAppointmentsQuery = z.object({
    patient_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    status: z.string().nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated appointment list
 */
export const zListAppointmentsResponse = zPaginatedResponseAppointmentResponse;

export const zCreateAppointmentBody = zCreateAppointmentRequest;

/**
 * Appointment created
 */
export const zCreateAppointmentResponse = zAppointmentResponse;

export const zDeleteAppointmentPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Appointment deleted
 */
export const zDeleteAppointmentResponse = z.void();

export const zGetAppointmentPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Appointment detail
 */
export const zGetAppointmentResponse = zAppointmentResponse;

export const zUpdateAppointmentBody = zUpdateAppointmentRequest;

export const zUpdateAppointmentPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Appointment updated
 */
export const zUpdateAppointmentResponse = zAppointmentResponse;

export const zArrivePath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Arrival recorded; the chart is open
 */
export const zArriveResponse = zAppointmentResponse;

export const zCancelAppointmentBody = zCancelAppointmentRequest;

export const zCancelAppointmentPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Appointment cancelled
 */
export const zCancelAppointmentResponse = zAppointmentResponse;

export const zCheckInAppointmentBody = zCheckInRequest.nullable();

export const zCheckInAppointmentPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Registration complete
 */
export const zCheckInAppointmentResponse = zAppointmentResponse;

export const zMarkNoShowBody = zMarkNoShowRequest;

export const zMarkNoShowPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Appointment marked as a no-show
 */
export const zMarkNoShowResponse = zAppointmentResponse;

export const zStartVisitPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Visit started; the encounter is now active
 */
export const zStartVisitResponse = zAppointmentResponse;

export const zListScheduleTemplatesQuery = z.object({
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish()
});

/**
 * Schedule templates
 */
export const zListScheduleTemplatesResponse = z.array(zScheduleTemplateResponse);

export const zCreateScheduleTemplateBody = zCreateScheduleTemplateRequest;

/**
 * Schedule template created
 */
export const zCreateScheduleTemplateResponse = zScheduleTemplateResponse;

export const zListAvailableSlotsQuery = z.object({
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    facility_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    department_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    date_from: z.string().nullish(),
    date_to: z.string().nullish(),
    duration_minutes: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Available appointment slots
 */
export const zListAvailableSlotsResponse = z.array(zAvailableSlotResponse);

export const zListWaitlistQuery = z.object({
    provider_id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    status: z.string().nullish(),
    page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish(),
    per_page: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }).nullish()
});

/**
 * Paginated waitlist
 */
export const zListWaitlistResponse = zPaginatedResponseWaitlistResponse;

export const zUpdateWaitlistEntryBody = zUpdateWaitlistRequest;

export const zUpdateWaitlistEntryPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * Updated waitlist entry
 */
export const zUpdateWaitlistEntryResponse = zWaitlistResponse;

export const zListAppsQuery = z.object({
    display_in_chart: z.boolean().nullish(),
    display_in_sidebar: z.boolean().nullish(),
    app_category: z.string().nullish(),
    is_active: z.boolean().nullish()
});

/**
 * Configured third-party apps (filtered)
 */
export const zListAppsResponse = z.array(zThirdPartyAppResponse);

export const zCreateAppBody = zCreateAppRequest;

/**
 * App created
 */
export const zCreateAppResponse = zThirdPartyAppResponse;

export const zLaunchAppBody = zLaunchRequest;

export const zLaunchAppPath = z.object({
    app_code: z.string()
});

/**
 * Signed launch URL + method
 */
export const zLaunchAppResponse = zLaunchResponse;

export const zDeactivateAppPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * App deactivated
 */
export const zDeactivateAppResponse = z.void();

export const zGetAppPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * App config
 */
export const zGetAppResponse = zThirdPartyAppResponse;

export const zUpdateAppBody = zUpdateAppRequest;

export const zUpdateAppPath = z.object({
    id: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

/**
 * App updated
 */
export const zUpdateAppResponse = zThirdPartyAppResponse;

export const zListDemographicValueSetsQuery = z.object({
    kind: z.string().optional(),
    jurisdiction: z.string().optional()
});
